import {
  message,
  Modal,
  Menu,
  Spin,
  Row,
  Col,
  Select,
  Button,
  Dropdown,
  //Form as FormInitial,
  //Tabs,
  PageHeader,
  Popconfirm,
  Tooltip
} from "antd";
import React, { Component } from "react";
import {
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  dineroDisabledMask,
  DatePickerItem,
  //BoxItem,
  //HeaderItem,
  InputItem,
  ButtonItem,
  SwitchItem,
  round2Decimals,
  NotificacionMovimientosInventario,
  DisponibilidadInsumoModal,
  HistorialInsumoClienteModal,
  DetalleInsumoModal,
  ComponentesKitModal,
  MensajeError,
} from "../../../../Components/Items";
import VentasForm from "../../../../Components/VentasForm";
import moment from "moment";
import axios from "axios";
import { connect } from "react-redux";
import {
  BookOutlined,
  BuildOutlined,
  CarOutlined,
  DollarOutlined,
  DownOutlined,
  DownloadOutlined,
  EditOutlined,
  FileExcelOutlined,
  FileOutlined,
  RocketOutlined,
  SendOutlined,
  SnippetsOutlined,
  SwapOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { descargarExcelDocumento } from "../../../../Components/DescargarDocumentosMasivo";
import facturaPdf from "../../../../Pdf/facturaPdf";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import MandarCorreo from "../MandarCorreo/MandarCorreo";
import PagosVenta from "../PagosVenta/PagosVenta";
import remisionPdf from "../../../../Pdf/remisionPdf";
import MandarCorreoFacturaGlobal from "../MandarCorreoFacturaGlobal/MandarCorreoFacturaGlobal";
import ModalCancelarPdf from "../CancelarVenta/ModalCancelarPdf/ModalCancelarPdf";
import TabEnvio from "../AgregarVenta/TabEnvio/TabEnvio";
import TabEntregaDireccion from "../../../../Components/TabEntregaDireccion";
import NotasDeCreditoVenta from "../../NotasDeCreditoVenta/NotasDeCreditoVenta/NotasDeCreditoVenta";
import DevolucionesVenta from "../../Devoluciones/DevolucionesVenta/DevolucionesVenta";
import IconAd2 from "../../../../Icons/IconAd2";
import TabRelaciones from "../AgregarVenta/TabRelaciones/TabRelaciones";
import ticketPdf from "../../../../Pdf/ticketPdf";
import printJS from "print-js";
import qz from "qz-tray";
import {
  IconFileInvoice
} from "../../../../Icons/Icons";
import ModalRefacturarVenta from "../ModalRefacturarVenta/ModalRefacturarVenta";
import ModalFacturarQuitarGlobal from "../ModalFacturarQuitarGlobal/ModalFacturarQuitarGlobal";
import RastrearRequisicion from "../RastrearRequisicion/RastrearRequisicion";
import EntregasVenta from "../EntregasVenta/EntregasVenta";
import TrazabilidadSteps from "../TrazabilidadSteps/TrazabilidadSteps";
import ModalVerFacturaVariasRemisiones from "../ModalVerFacturaVariasRemisiones/ModalVerFacturaVariasRemisiones";
import ModalVerRemisionesVariasFactura from "../ModalVerRemisionesVariasFactura/ModalVerRemisionesVariasFactura";
import EnviarCorreoCostearVenta from "../CostearVenta/CostearInsumo/EnviarCorreoCostearVenta/EnviarCorreoCostearVenta";
import CambiarInsumoVenta from "./CambiarInsumoVenta/CambiarInsumoVenta";
import EditarRemisionVenta from "./EditarRemisionVenta/EditarRemisionVenta";
import ModalDividirVenta from "./ModalDividirVenta/ModalDividirVenta";
import ModalGenerarGuia from "../../VentasEcommerce/Components/ModalGenerarGuia"
import ModalGenerarOCDropshipping from "../../VentasEcommerce/Components/ModalGenerarOCDropshipping"
import ModalGenerarGuiaManual from "../../VentasEcommerce/Components/ModalGenerarGuiaManual"
import ApartadosVenta from "../ApartadosVenta/ApartadosVenta";
import ModalResumenInsumos from "../ModalResumenInsumos/ModalResumenInsumos";
import ModalQuitarApartadoIndividual from "../../Pedidos/VerPedido/ModalQuitarApartadoIndividual/ModalQuitarApartadoIndividual";
import ModalItem from "../../../../Components/ModalItem";
import MandarCorreoCartaTrasladoRemision from "../MandarCorreoCartaTrasladoRemision/MandarCorreoCartaTrasladoRemision";
import CancelarCartaTrasladoRemision from "../CancelarCartaTrasladoRemision/CancelarCartaTrasladoRemision";
import ModalPolizasDocumento from "../../../../Components/ModalPolizasDocumento";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
//const { TabPane } = Tabs
class VerVenta extends Component {
   formRef = React.createRef();
    state = {
      loading: false,
      factura: false,
      sinContabilidad: false,
      nombreFactura: '',
      objetoClientes: null,
      todasClientes: null,
      objetoProyectos: null,
      todasProyectos: null,
      objetoPrecios: null,
      todasPrecios: null,
      objetoFormasDePago: null,
      todasFormasDePago: null,
      objetoInsumos: null,
      todasInsumos: null,
      objetoUsosDeCFDI: null,
      todasUsosDeCFDI: null,
      objetoBancos: null,
      todasBancos: null,
      objetoUsuarios: null,
      todasUsuarios: null,
      objetoMonedas: null,
      todasMonedas: null,
      impuestos: [],
      total: 0,
      subtotal: 0,
      totalCantidadInsumos: 0,
      arrayImpuestos: [],
      arrayRetenciones: [],
      totalPagar: 0,
      modalCorreo: false,
      modalPagos: false,
      modalCorreoId: null,
      modalPolizas: false,
      estado: 0,
      totalPagado: 0,
      id: this.props.location.state.id,
      descargandoExcel: false,
      facturaGlobal: false,
      facturaGlobalId: null,
      modalVerFacturaGlobal: false,
      modalVerFacturaGlobalId: null,
      modalCancelarPdf: false,
      modalcancelarPdfId: null,
      ubicacionesEnvio: [],
      mercanciasEnvio: [],
      flete: false,
      notaDeCredito: false,
      devolucion: false,
      modalNotasDeCreditoVenta: false,
      modalDevoluciones: false,
      objetoDoctores: null,
      todasDoctores: null,
      objetoPacientes: null,
      todasPacientes: null,
      cancelacion: null,
      requerido: false,
      ticket: null,
      activarRegimenes: true,
      todasRegimenFiscal: null,
      objetoRegimenFiscal: null,
      activeTabKey: "1",
      direccionesCliente: [],
      objetoDireccionesCliente: null,
      todasPaises: [],
      todasEstado: [],
      todasMunicipios: [],
      todasColonias: [],
      objetoPaises: null,
      objetoEstados: null,
      objetoMunicipios: null,
      objetoColonias: null,
      loadingEntrega: false,
      addendaMabe: false,
      loadingPlantasEntrega: false,
      apartado: false,
      modalQuitarApartadosIndividual: false,
      insumosParaQuitarApartado: [],
      objetoCanalesVenta: null,
      todasCanalesVenta: [],
      modalRefacturarVenta: false,
      ventaIdRefacturar: null,
      modalFacturarQuitarGlobal: false,
      facturaZip: null,
      cambioContadoACredito: false,
      cambioCreditoAContado: false,
      modalRastrearRequisicion: false,
      modalEntregas: false,
      insumosEntrega: null,
      insumosEntregaVenta: null,
      facturaId: null,
      remisionesIds: [],
      trace: null,
      modalVerFacturaVariasRemisiones: false,
      modalVerRemisionesVariasFactura: false,
      modalVisibleCorreoCosteo: false,
      modalVisibleCorreoCosteoId: null,
      entregas: [],
      tiposDescuento: {},
      // Datos para la venta online
      ventaOnline : false,
      clienteOnline : [],
      datosPagoOnline: null,
      referenciaPagoOnline: '',
      cotizacionesEnvioOnline : [],
      codigoBarrasUrl: null,
      clienteIdVenta: null,
      empresaClienteOnlineId: null,
      modalGuiaLocalVisible: false,
      modalGuiaDropshippingVisible: false,
      modalGuiaManualVisible: false,
      selectedOrigenKey: null,
      modalApartados: false,
      modalResumenInsumos: false,
      modalDisponibilidadVisible: false,
      insumoSeleccionadoDisponibilidad: { id: null, nombre: '' },
      modalHistorialClienteVisible: false,
      insumoSeleccionadoHistorial: { id: null, nombre: '', clienteId: null, index: 0 },
      modalDetalleInsumoVisible: false,
      insumoSeleccionadoDetalle: { id: null, nombre: '' },
      modalCambiarCliente: false,
      clientesCandidatos: [],
      loadingCambiarCliente: false,
      clienteNuevoId: null,
      modalCambiarInsumoVisible: false,
      modalCambiarInsumoData: null,
      modalEditarRemisionVisible: false,
      modalComponentesKitVisible: false,
      componentesKitSeleccionado: { componentes: [], cantidad: 0, nombre: '' },
      remisionSerie: null,
      remisionNumero: null,
      sufijoPartida: null,
      ventaPadreId: null,
      divisiones: [],
      insumosAnteriores: [],
      ventasDerivadas: [],
      modalDividirVentaVisible: false,
      insumosParaDividir: [],
    };

  componentDidMount() {
    this.consultarTodo();
  }

  // Navegar de VerVenta a VerVenta (ej. "Ver Venta Original"/"Ventas Derivadas") no
  // desmonta el componente -es la misma ruta-, así que sin esto this.state.id nunca
  // cambiaba y la pantalla se quedaba mostrando la venta vieja sin recargar nada.
  componentDidUpdate(prevProps) {
    const idNuevo = this.props.location.state?.id;
    const idAnterior = prevProps.location.state?.id;
    if (idNuevo && idNuevo !== idAnterior && idNuevo !== this.state.id) {
      this.setState({ id: idNuevo }, () => this.consultarTodo());
    }
  }

  abrirDisponibilidad = (insumoId, nombre, proyectoId) => {
    this.setState({ modalDisponibilidadVisible: true, insumoSeleccionadoDisponibilidad: { id: insumoId, nombre, proyectoId } });
  }

  cerrarDisponibilidad = () => {
    this.setState({ modalDisponibilidadVisible: false });
  }

  // Clic derecho en la misma celda donde el doble clic abre Disponibilidad. Pantalla de solo
  // lectura: no se pasa permitirUsarPrecio, asi que el modal no ofrece aplicar el precio.
  abrirHistorialCliente = (insumoId, nombre, index) => {
    if (!insumoId) return message.warning("Primero selecciona un insumo en el renglón");
    const clienteId = this.formRef.current?.getFieldValue("clienteId") || this.state.clienteIdVenta;
    if (!clienteId) return message.warning("Primero selecciona un cliente para ver su historial");
    this.setState({
      modalHistorialClienteVisible: true,
      insumoSeleccionadoHistorial: { id: insumoId, nombre, clienteId, index },
    });
  }

  cerrarHistorialCliente = () => {
    this.setState({ modalHistorialClienteVisible: false });
  }

  abrirDetalleInsumo = (insumoId, nombre) => {
    if (!insumoId) return;
    this.setState({ modalDetalleInsumoVisible: true, insumoSeleccionadoDetalle: { id: insumoId, nombre } });
  }

  cerrarDetalleInsumo = () => {
    this.setState({ modalDetalleInsumoVisible: false });
  }

  // Kit variable: la lista elegida para este renglon vive en el mismo form, en
  // insumos[arrayKey].componentesKit. Se manda tal cual al modal, que resuelve clave y unidad
  // contra el catalogo.
  abrirComponentesKit = (arrayKey) => {
    const componentes = this.formRef.current?.getFieldValue(['insumos', arrayKey, 'componentesKit']) || [];
    const cantidad = this.formRef.current?.getFieldValue(['insumos', arrayKey, 'cantidad']);
    const insumoId = this.formRef.current?.getFieldValue(['insumos', arrayKey, 'insumoId']);
    const insumoObj = this.state.todasInsumos?.find(i => i._id.toString() === insumoId?.toString());
    this.setState({
      modalComponentesKitVisible: true,
      componentesKitSeleccionado: {
        componentes,
        cantidad,
        nombre: insumoObj?.nombreClienteAlternativo || insumoObj?.nombre || insumoObj?.descripcion || '',
      },
    });
  }

  cerrarComponentesKit = () => {
    this.setState({ modalComponentesKitVisible: false });
  }

  abrirModalCambiarInsumo = (insumoVentaId, insumoId, proyectoId, entregado) => {
    this.setState({
      modalCambiarInsumoVisible: true,
      modalCambiarInsumoData: { insumoVentaId, insumoId, proyectoId, entregado },
    });
  }

  cerrarModalCambiarInsumo = (refrescar) => {
    this.setState({ modalCambiarInsumoVisible: false, modalCambiarInsumoData: null });
    if (refrescar) {
      this.consultarTodo();
    }
  }

  abrirModalEditarRemision = () => {
    this.setState({ modalEditarRemisionVisible: true });
  }

  cerrarModalEditarRemision = (refrescar) => {
    this.setState({ modalEditarRemisionVisible: false });
    if (refrescar) {
      this.consultarTodo();
    }
  }

  abrirModalDividirVenta = () => {
    const insumos = this.formRef.current?.getFieldValue('insumos') || [];
    this.setState({ modalDividirVentaVisible: true, insumosParaDividir: insumos });
  }

  cerrarModalDividirVenta = (resultado) => {
    this.setState({ modalDividirVentaVisible: false });
    if (!resultado) return;
    Modal.confirm({
      title: `Se creó la partida ${resultado.folio}`,
      content: '¿Deseas facturarla ahora?',
      okText: 'Sí, facturar',
      cancelText: 'No, más tarde',
      onOk: () => this.props.history.push('/panel/generarFacturaVenta', { id: resultado.ventaId }),
      onCancel: () => this.consultarTodo(),
    });
  }

  abrirModalCambiarCliente = () => {
    const clienteActual = this.state.todasClientes?.[0];
    if (!clienteActual?.rfc) {
      message.warning('El cliente actual no tiene RFC registrado.');
      return;
    }
    this.setState({ loadingCambiarCliente: true });
    axios.post('clientes/selectClientesPorRfc', {
      empresaId: this.props.empresaId,
      rfc: clienteActual.rfc,
      excluirClienteId: clienteActual._id,
    }, { headers: this.props.headersToken })
      .then(res => {
        this.setState({ loadingCambiarCliente: false });
        if (res.data.success === 2 && res.data.clientes?.length > 0) {
          this.setState({ clientesCandidatos: res.data.clientes, modalCambiarCliente: true, clienteNuevoId: null });
        } else {
          message.info('No se encontraron otros clientes con el mismo RFC.');
        }
      })
      .catch(() => {
        this.setState({ loadingCambiarCliente: false });
        message.error('Error al buscar clientes.');
      });
  }

  ejecutarCambiarCliente = () => {
    if (!this.state.clienteNuevoId) {
      message.warning('Selecciona un cliente.');
      return;
    }
    this.setState({ loadingCambiarCliente: true });
    axios.post('ventas/cambiarClienteVenta', {
      ventaId: this.state.id,
      empresaId: this.props.empresaId,
      nuevoClienteId: this.state.clienteNuevoId,
    }, { headers: this.props.headersToken })
      .then(res => {
        this.setState({ loadingCambiarCliente: false });
        if (res.data.success === 2) {
          message.success('Cliente actualizado exitosamente.');
          this.setState({ modalCambiarCliente: false });
          this.consultarTodo();
        } else {
          message.warning(res.data.message || 'No se pudo cambiar el cliente.');
        }
      })
      .catch(() => {
        this.setState({ loadingCambiarCliente: false });
        message.error('Error al cambiar cliente.');
      });
  }

  esVentaOnlineGenerica = () => {
    const { ventaOnline, clienteIdVenta, empresaClienteOnlineId } = this.state;
    if (!ventaOnline || !clienteIdVenta || !empresaClienteOnlineId) return false;
    return clienteIdVenta.toString() === empresaClienteOnlineId.toString();
  };

  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "ventas/selectDatosParaVenta",
        { empresaId: this.props.empresaId, mostrarDeshabilitados: true, ventaId: this.state.id },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({
            desactivarBtnCXC: res.data.desactivarBtnCXC,
            addendaMabe: res.data.clientes[0].addendaMabe || false,
            insumosEntrega: res.data.insumos,
            insumosEntregaVenta: res.data.insumosVenta,
            apartado: res.data.apartado || false,
            totalPagado: res.data.totalPagado,
            estado: res.data.estado,
            estadoPago: res.data.estadoPago,
            contado: res.data.contado,
            factura: res.data.factura,
            remisionesIds: res.data.remisionesIds || [],
            facturaId: res.data.facturaId || null,
            remisionSerie: res.data.remisionSerie,
            remisionNumero: res.data.remisionNumero,
            sufijoPartida: res.data.sufijoPartida || null,
            ventaPadreId: res.data.ventaPadreId || null,
            divisiones: res.data.divisiones || [],
            insumosAnteriores: res.data.insumosAnteriores || [],
            ventasDerivadas: res.data.ventasDerivadas || [],
            ajusteFacturaDevolucion: res.data.ajusteFacturaDevolucion && res.data?.ajusteFacturaDevolucion?.insumosExcluidos?.length ? res.data.ajusteFacturaDevolucion : null,
            notaDeCredito: res.data.notaDeCredito,
            devolucion: res.data.devolucion,
            nombreFactura: (res.data.remision ? (res.data.remisionSerie + ' - ' + res.data.remisionNumero + (res.data.sufijoPartida ? (' ' + res.data.sufijoPartida) : '')) : '') + ((res.data.remision && res.data.factura) ? ' | ' : '') + (res.data.factura ? (res.data.facturaSerie + ' - ' + res.data.facturaNumero) : ''),
            remision: res.data.remision,
            total: res.data.total,
            subtotal: res.data.subtotal,
            totalCantidadInsumos: (res.data.insumos || []).reduce(
              (suma, insumo) => suma + (Number(insumo.cantidad) || 0),
              0
            ),
            arrayImpuestos: res.data.arrayImpuestos,
            totalPagar: res.data.totalPagar,
            arrayRetenciones: res.data.arrayRetenciones,
            facturaGlobal: res.data.facturaGlobal,
            facturaGlobalId: res.data.facturaGlobalId,
            ubicacionesEnvio: res.data.ubicacionesEnvio,
            mercanciasEnvio: res.data.mercanciasEnvio,
            dataCartaPorteTraslado: res.data.dataCartaPorteTraslado,
            cancelacionCartaPorteTraslado: res.data.cancelacionCartaPorteTraslado,
            cancelacion: res.data.cancelacion,
            requerido: res.data.requerido,
            flete: res.data.flete || (res.data.ubicacionesEnvio?.length > 0 && res.data.mercanciasEnvio?.length > 0),
            ticket: res.data.tickets,
            todasClientes: res.data.clientes,
            todasProyectos: res.data.proyectos,
            todasPrecios: res.data.precios,
            todasFormasDePago: res.data.formasDePago,
            todasUsosDeCFDI: res.data.usosDeCFDI,
            todasBancos: res.data.bancosYCajas,
            todasInsumos: res.data.insumosVenta,
            todasUsuarios: res.data.usuariosEmpresa,
            todasMonedas: res.data.monedas,
            activarRegimenes: res.data.activarRegimenes,
            todasRegimenFiscal: res.data.regimenesFiscales,
            todasCanalesVenta: res.data.canalesVenta,
            tickets: res.data.tickets,
            facturaZip: res.data.facturaZip || null,
            cambioContadoACredito: res.data.cambioACredito || false,
            cambioCreditoAContado: res.data.cambioAContado || false,
            trace: res.data.trace || null,
            clienteOnline: res.data.clienteOnline,
            datosPagoOnline: res.data.datosPagoOnline || null,
            referenciaPagoOnline:
              res.data.datosPagoOnline?.referencia ||
              res.data.referencia ||
              res.data.referenciaConekta ||
              '',
            cotizacionesEnvioOnline : res.data.cotizacionesEnvioOnline,
            ventaOnline: res.data.ventaOnline || false,
            facturarConDevoluciones: res.data.facturarConDevoluciones || false,
            clienteIdVenta: res.data.clienteId || null,
            empresaClienteOnlineId: res.data.empresaClienteOnlineId || null,
            objetoClientes: res.data.clientes.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.stringBuscar}
                </Option>
              );
            }),
            objetoProyectos: res.data.proyectos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            objetoPrecios: res.data.precios.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            objetoFormasDePago: res.data.formasDePago.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value?.c_FormaPago + ' - ' + value.descripcion}
                </Option>
              );
            }),
            objetoUsosDeCFDI: res.data.usosDeCFDI.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value?.c_UsoCFDI + ' - ' + value.descripcion}
                </Option>
              );
            }),
            objetoBancos: res.data.bancosYCajas.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            objetoInsumos: res.data.insumosVenta.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombreClienteAlternativo || value.nombre || value.descripcion}
                </Option>
              );
            }),
            objetoUsuarios: res.data.usuariosEmpresa.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre +
                    " " +
                    value.apellidoPaterno +
                    " " +
                    value.apellidoMaterno}
                </Option>
              );
            }),
            objetoMonedas: res.data.monedas.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviacion}
                </Option>
              );
            }),
            objetoRegimenFiscal: res.data.regimenesFiscales.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.c_RegimenFiscal + " - " + value.descripcion}
                </Option>
              );
            }),
            objetoCanalesVenta: res.data.canalesVenta.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            direccionesCliente: res.data.clientes?.[0]?.direcciones || [],
          });
          if (res.data.tickets) {
            this.activarQzTray()
          }
          const tiposDescuentoIniciales = {};
          (res.data.insumos || []).forEach((insumo, index) => {
              if (insumo.descuentoCantidad && insumo.descuentoCantidad > 0) {
                  tiposDescuentoIniciales[index] = 'cantidad';
              } else {
                  tiposDescuentoIniciales[index] = 'porcentaje';
              }
          });

          this.setState({
            tiposDescuento: tiposDescuentoIniciales,
            sinContabilidad: !!res.data.sinContabilidad,
          });
          this.formRef.current.setFieldsValue({
            ...res.data,
            factura: res.data.factura ? 1 : (res.data.sinContabilidad ? 3 : 2),
            fechaEntregaEstimada: res.data.fechaEntregaEstimada
              ? moment(res.data.fechaEntregaEstimada)
              : undefined,
            fechaVenta: res.data.fechaFactura
              ? moment(res.data.fechaFactura)
              : moment(res.data.fechaRemision),
            //moment(undefined) devuelve hoy, así que una venta sin estos datos
            //mostraría la fecha de hoy como si fuera un dato capturado
            fechaPago: res.data.fechaPago ? moment(res.data.fechaPago) : undefined,
            fechaVencimiento: res.data.fechaVencimiento ? moment(res.data.fechaVencimiento) : undefined,
            fechaPagoInformativa: res.data.fechaPagoInformativa
              ? moment(res.data.fechaPagoInformativa)
              : undefined,
            insumos: res.data.insumos.map((insumo) => {
              const precioUnitario = Number(insumo.precioUnitario)

              const insumoBuscar = this.state.todasInsumos.find(
                (insumoTodas) => insumoTodas._id.toString() === insumo.insumoId.toString()
              );

              let totalImpuestosPrecioSinImpuestos = 0;
              let precioUnitarioConImpuestos = 0;
              if (insumoBuscar) {
                insumoBuscar.impuestos.map((valueImpuesto) => {
                  let totalImpuesto;
                  if (valueImpuesto.tasaCuota === 1) {
                    totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
                  } else if (valueImpuesto.tasaCuota === 2) {
                    totalImpuesto =
                      (precioUnitario + totalImpuestosPrecioSinImpuestos) *
                      (valueImpuesto.monto / 100);
                  } else if (valueImpuesto.tasaCuota === 3) {
                    totalImpuesto = (valueImpuesto.monto / res.data.tipoDeCambio);
                  } else if (valueImpuesto.tasaCuota === 5) {
                    totalImpuesto = 0
                  }
                  totalImpuestosPrecioSinImpuestos += totalImpuesto;
                  return null;
                });
                precioUnitarioConImpuestos = round2Decimals(
                  precioUnitario + totalImpuestosPrecioSinImpuestos
                );
              } else {
                precioUnitarioConImpuestos =
                  insumo.precioUnitario + insumo.impuestos / insumo.cantidad;
              }
              return { ...insumo, precioUnitarioConImpuestos };
            }),
          });
        }
      });

    if (this.props.equipoMedico) {

      await axios
        .post(
          "ventas/selectDatosParaEquipoMedico",
          { empresaId: this.props.empresaId },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.success === 2) {
            this.setState({
              todasDoctores: res.data.doctores,
              todasPacientes: res.data.pacientes,
              todasCirugias: res.data.cirugias,
              objetoDoctores: res.data.doctores.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.codigo + ' - ' + value.nombre}
                  </Option>
                );
              }),
              objetoPacientes: res.data.pacientes.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.codigo + ' - ' + value.nombre}
                  </Option>
                );
              }),
              objetoCirugias: res.data.cirugias.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.codigo + ' - ' + value.nombre}
                  </Option>
                );
              }),
            });
          } else {
            message.error('No se encontraron datos de equipo medico')
          }
        });

    }
    this.setState({ loading: false });
  }
  atras() {
    this.props.history.goBack();
  }

  descargarXml(value) {
    axios
      .post(
        "ventas/datosPdf",
        { ventaId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.factura) {
          const xmltext = res.data.respuestaFactura.data.cfdi;
          const dataSat = res.data.respuestaFactura.dataSat;

          const nombreArchivo =
            (dataSat.Serie ? dataSat.Serie : "F") +
            " - " +
            dataSat.Folio +
            " ( " +
            dataSat.Receptor.Rfc +
            " - " +
            dataSat.Receptor.Nombre +
            " )";

          // Descargar el XML como archivo
          const blob = new Blob([xmltext], { type: "application/xml" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `${nombreArchivo}.xml`;
          link.click();
        } else {
          console.warn("No se generó factura para esta venta.");
        }
      });
  }

  descargarPDF(value) {
    axios
      .post(
        "ventas/datosPdf",
        { ventaId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.factura) {
          const dataSat = res.data.respuestaFactura.dataSat;

          const nombreArchivo =
            (dataSat.Serie ? dataSat.Serie : "F") +
            " - " +
            dataSat.Folio +
            " ( " +
            dataSat.Receptor.Rfc +
            " - " +
            dataSat.Receptor.Nombre +
            " )";

          const pdf = facturaPdf(res.data);
          pdfMake.createPdf(pdf).download(nombreArchivo + ".pdf");
        } else {
          const dataSat = res.data.respuestaFactura.dataSat;
          const nombreArchivo =
            (dataSat.Serie ? dataSat.Serie : "R") +
            " - " +
            dataSat.Folio +
            " ( " +
            dataSat.Receptor.Nombre +
            " )";

          const pdf = remisionPdf(res.data);
          pdfMake.createPdf(pdf).download(nombreArchivo + ".pdf");
        }
      });
  }

  async descargarExcel() {
    this.setState({ descargandoExcel: true });
    await descargarExcelDocumento({
      modulo: "venta",
      id: this.state.id,
      empresaId: this.props.empresaId,
      headersToken: this.props.headersToken,
    });
    this.setState({ descargandoExcel: false });
  }

  enviarVenta(value) {
    this.setState({ modalCorreo: true, modalCorreoId: value });
  }
  cerrarMandarCorreo() {
    this.setState({
      modalCorreo: false,
      modalCorreoId: null,
    });
  }
  cerrarModalCancelarPdf() {
    this.setState({
      modalCancelarPdf: false,
      modalcancelarPdfId: null,
    });
  }


  abrirModalCancelarPdf() {
    this.setState({
      modalCancelarPdf: true,
      modalcancelarPdfId: this.props.id,
    });
  }

  emitirCartaTrasladoRemision() {
    this.setState({ loading: true });
    axios
      .post(
        "ventas/emitirCartaTrasladoRemision",
        { ventaId: this.state.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Carta de Traslado emitida");
          this.consultarTodo();
          this.setState({ modalCartaTrasladoVisible: true });
        } else if (res.data.success === 1) {
          // Un rechazo del SAT no cabe en un toast de una línea: va al overlay, con el
          // detalle técnico plegado y sin cierre automático.
          MensajeError({
            message: res.data.errorTimbrado?.titulo || res.data.message || "No se pudo emitir la Carta de Traslado",
            description: res.data.errorTimbrado?.mensaje || res.data.description,
            detalleTecnico: res.data.errorTimbrado?.detalleTecnico,
          });
        } else {
          message.error("Hubo un error y no se pudo emitir la Carta de Traslado");
        }
      });
  }
  abrirModalCartaTraslado() {
    this.setState({ modalCartaTrasladoVisible: true });
  }
  cerrarMandarCorreoCartaTrasladoRemision() {
    this.setState({ modalCartaTrasladoVisible: false });
  }
  abrirModalCancelarCartaTraslado() {
    this.setState({ modalCancelarCartaTrasladoVisible: true });
  }
  cerrarCancelarCartaTrasladoRemision() {
    this.setState({ modalCancelarCartaTrasladoVisible: false });
  }
  actualizarDespuesDeCancelarCartaTraslado() {
    this.setState({ modalCancelarCartaTrasladoVisible: false });
    this.consultarTodo();
  }


  cerrarPagosVenta() {
    this.consultarTodo();
    this.setState({
      modalPagos: false,
    });
  }

  etiquetaOrigenEnvio = (origen) => {
    switch (origen) {
      case "bodega_local":
        return "Bodega Local";
      case "dropshipping_urrea":
        return "Dropshipping Urrea";
      case "envio_manual":
        return "Envío Manual";
      case "entrega_sucursal":
        return "Recoger en Sucursal";
      default:
        return origen || "—";
    }
  };

  abrirModalEnvio = (origen) => {
    if (!origen) return;
    this.setState({ selectedOrigenKey: origen });
    if (origen === "bodega_local") {
      this.setState({ modalGuiaLocalVisible: true });
    } else if (origen === "dropshipping_urrea") {
      this.setState({ modalGuiaDropshippingVisible: true });
    } else if (origen === "envio_manual") {
      this.setState({ modalGuiaManualVisible: true });
    }
  };

  cerrarModalEnvio = () => {
    this.setState({
      modalGuiaLocalVisible: false,
      modalGuiaDropshippingVisible: false,
      modalGuiaManualVisible: false,
      selectedOrigenKey: null,
    });
  };

  onSuccessModalEnvio = () => {
    this.cerrarModalEnvio();
    this.consultarTodo();
  };

  cerrarEntregasVenta() {
    this.consultarTodo();
    this.setState({
      modalEntregas: false,
    });
  }

  cerrarMandarCorreoFacturaGlobal() {
    this.setState({
      modalVerFacturaGlobal: false,
      modalVerFacturaGlobalId: null,
    });
  }
  verFacturaGlobal(facturaGlobalId) {
    this.setState({
      modalVerFacturaGlobal: true,
      modalVerFacturaGlobalId: facturaGlobalId,
    });
  }
  editarUbicacionesEnvio(value) {
    this.setState({ ubicacionesEnvio: value })
  }

  editarMercanciasEnvio(value) {
    this.setState({ mercanciasEnvio: value })
  }

  agregarNotaDeCreditoVenta() {
    this.props.history.push('/panel/agregarNotaDeCreditoVenta', { ventaId: this.state.id });
  }

  cerrarNotasDeCreditoVenta() {
    this.setState({ modalNotasDeCreditoVenta: false });
  }

  agregarDevolucion() {
    this.props.history.push('/panel/agregarDevolucion', { ventaId: this.state.id });
  }

  cerrarDevolucionesVenta() {
    this.setState({ modalDevoluciones: false });
  }

  requerirInsumos() {
    if (this.state.requerido) {
      Modal.confirm({
        title: 'Ya existe una requisición para esta venta',
        content: '¿Deseas crear otra requisición de cualquier forma?',
        okText: 'Sí, crear otra',
        cancelText: 'Cancelar',
        onOk: () => this.props.history.push('/panel/requerirInsumosVenta', { ventaId: this.state.id }),
      });
      return;
    }
    this.props.history.push('/panel/requerirInsumosVenta', { ventaId: this.state.id });
  }

  imprimirTicket(value) {
    axios
      .post(
        "ventas/datosPdf",
        { ventaId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (this.state.ticket) {
          this.printTicket(res.data)
        } else {
          const pdf2 = ticketPdf(res.data);
          pdfMake.createPdf(pdf2).getBlob((blob) => {
            const pdfURL = URL.createObjectURL(blob);

            // Imprimir el PDF automáticamente
            printJS({
              printable: pdfURL,
              type: "pdf",
              showModal: false,
            });

            // Liberar el objeto URL
            URL.revokeObjectURL(pdfURL);
          });
        }
      });
  }

  async cambiarACredito() {
    await axios
      .post(
        "ventas/cambiarACredito",
        { empresaId: this.props.empresaId, ventaId: this.state.id },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.consultarTodo();
          message.success({
            content: ' Venta cambiada a crédito exitosamente',
            duration: 3,
          });
        } else {
          message.warning({
            content: 'No se pudo cambiar la venta a crédito',
            duration: 4,
          });
        }
      })

  }

  async cambiarAContado() {
    await axios
      .post(
        "ventas/cambiarAContado",
        { empresaId: this.props.empresaId, ventaId: this.state.id },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.consultarTodo();
          message.success({
            content: ' Venta cambiada a contado exitosamente',
            duration: 3,
          });
        } else {
          message.warning({
            content: 'No se pudo cambiar la venta a contado',
            duration: 4,
          });
        }
      })

  }

  editarCanalVenta(canalDeVentaId) {
    axios
      .post(
        "ventas/editarCanalVenta",
        { ventaId: this.state.id, empresaId: this.props.empresaId, canalDeVentaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Canal de venta actualizado");
        } else {
          message.info("La venta no se editó");
        }
      });
  }

  async onChangeEstado(value, inicial) {
    if (!inicial) {
      this.formRef.current.setFieldsValue({
        direccionEntrega: {
          municipioId: undefined,
          coloniaId: undefined
        }
      });
    }
    await axios
      .post(
        "municipios/selectMunicipios",
        { estadoId: value },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          let objetoMunicipios = res.data.map((value) => {
            return (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            );
          });
          this.setState({
            todasMunicipios: res.data,
            objetoMunicipios: objetoMunicipios,
          });
        }
      });
  }

  async onChangeMunicipio(value, inicial) {
    await axios
      .post(
        "colonias/selectColonias",
        { municipioId: value },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          let objetoColonias = res.data.map((value) => {
            return (
              <Option value={value._id} key={value._id}>
                {value.cp + " - " + value.nombre}
              </Option>
            );
          });
          this.setState({
            todasColonias: res.data,
            objetoColonias: objetoColonias,
          });
        }
      });
  }


  async onSearchColonia(value) {
    if (value.toString().length === 5) {
      await axios
        .post(
          "colonias/buscarCP",
          { cp: value },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.status === 404) {
            message.info("No se encontro el codigo postal");
          } else {
            this.formRef.current.setFieldsValue({
              direccionEntrega: {
                paisId: res.data.paisId,
                estadoId: res.data.estadoId,
                municipioId: res.data.municipioId
              }
            });
            this.onChangeEstado(res.data.estadoId, true);
            this.onChangeMunicipio(res.data.municipioId, true);
          }
        });
    }
  }
  async onSelectColoniaId(coloniaId, fieldKey) {
    const direccionEntrega = this.formRef.current.getFieldValue("direccionEntrega");
    if (!direccionEntrega?.colonia) {
      const nombreColonia = this.state.todasColonias.find((todasColonia) => todasColonia._id.toString() === coloniaId.toString())?.nombre
      await this.formRef.current.setFieldsValue({
        direccionEntrega: {
          colonia: nombreColonia
        }
      })
    }
  }

  async handleChangeDireccionEntrega(value) {
    this.setState({ loadingEntrega: true })
    if (value) {
      const direccion = this.state.direccionesCliente.find((direccion) => direccion._id.toString() === value.toString())
      if (direccion) {
        if (direccion.estadoId) {
          await this.onChangeEstado(direccion.estadoId, true);
        }
        if (direccion.municipioId) {
          await this.onChangeMunicipio(direccion.municipioId, true);
        }
        if (direccion?.plantaEntregaId) {
          this.onSearchPlantaEntrega(direccion?.plantaEntregaId, "direccionEntrega", { byId: true, setSelected: false });
        }
        this.formRef.current.setFieldsValue({
          direccionEntrega: {
            paisId: direccion.paisId,
            estadoId: direccion.estadoId,
            municipioId: direccion.municipioId,
            coloniaId: direccion.coloniaId,
            colonia: direccion.colonia,
            calle: direccion.calle,
            numeroCalle: direccion.numeroCalle,
            numeroInterior: direccion.numeroInterior,
            descripcion: direccion.descripcion,
            telefono: direccion.telefono,
            correo: direccion.correo,
            observaciones: direccion.observaciones,
            plantaEntregaId: direccion?.plantaEntregaId,
            referencia: direccion?.referencia,
          }
        })
      }
    }
    this.setState({ loadingEntrega: false })
  }

  handleDireccionEntregaChange = async (direccionValues) => {
    // Callback desde TabEntregaDireccion cuando se guardan cambios en el modal
    if (direccionValues) {
      this.formRef.current?.setFieldsValue({
        direccionEntrega: direccionValues
      });
      this.setState({ 
        direccionEntregaData: direccionValues 
      });
    }
  }

  cerrarModalCorreoCosteo(){
    this.setState({
      modalVisibleCorreoCosteo: false,
      modalVisibleCorreoCosteoId: null,
    })
  }

  consultarInformacionEntrega() {
    if (this.state.todasPaises.length > 0) return
    this.setState({ loadingEntrega: true })
    const direccionEntrega = this.formRef.current.getFieldValue("direccionEntrega");
    if (direccionEntrega?.plantaEntregaId && this.state.addendaMabe) {
      this.onSearchPlantaEntrega(direccionEntrega?.plantaEntregaId, "direccionEntrega", { byId: true, setSelected: false });
    }

    axios.post("direcciones/selectInformacionDomicilio", { direccion: direccionEntrega }, {
      headers: this.props.headersToken
    })
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            loadingEntrega: false,
            todasPaises: res.data.paises,
            todasEstado: res.data.estados,
            todasMunicipios: res.data.municipios,
            todasColonias: res.data.colonias,
            objetoMunicipios: res.data.municipios.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            objetoColonias: res.data.colonias.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.cp + " - " + value.nombre}
                </Option>
              );
            }),
            objetoPaises: res.data.paises.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviatura}
                </Option>
              );
            }),
            objetoEstados: res.data.estados.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviatura}
                </Option>
              );
            }),
          })
        } else {
          message.info("No se encontró información para entrega")
          this.setState({
            loadingEntrega: false
          })
        }
      })
  }
  onSearchPlantaEntrega = (value, fieldKey, opts = {}) => {
    const { byId = false, setSelected = false } = opts;
    if (byId) {
      axios
        .post(
          "plantaDeEntrega/selectPlantaEntregaPorId",
          { id: value },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          const p = res?.data?.dato || null;
          if (!p || !p._id) {
            this.setState(prev => ({
              objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
              loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
            }));
            message.warning("No se encontró la planta por ID.");
            return;
          }

          const option = (
            <Option key={p._id} value={p._id} padre={p.plantaEntregaId}>
              {p.label}
            </Option>
          );

          this.setState(prev => ({
            objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [option] },
            loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
          }));

          if (setSelected && (this.props.form?.setFieldsValue || this.form?.setFieldsValue)) {
            const form = this.props.form || this.form;
            form.setFields([
              { name: ['"direccionEntrega"', fieldKey, 'plantaEntregaId'], value: p._id }
            ]);
          }
        })
        .catch((err) => {
          console.error(err);
          message.error("Error al buscar planta por ID");
          this.setState(prev => ({
            objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
            loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
          }));
        });

      return;
    }
    this.setState(prev => ({
      loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: true }
    }));
    axios
      .post(
        "plantaDeEntrega/selectPlantasDeEntrega",
        {
          query: value || ""
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res?.data.success !== 2) {
          this.setState(prev => ({
            objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
            loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
          }));
          return;
        }
        const items = Array.isArray(res.data.plantas) ? res.data.plantas : [];
        const options = items.map(it => (
          <Option key={it._id} value={it._id} padre={it.plantaEntregaId}>
            {it.label}
          </Option>
        ));

        this.setState(prev => ({
          objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: options },
          loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
        }));
      })
      .catch((err) => {
        console.error(err);
        message.error("Error al buscar plantas de entrega");
        this.setState(prev => ({
          objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
          loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
        }));
      });
  }
  apartarInsumos() {
    this.props.history.push('/panel/apartarInsumosVenta', { ventaId: this.state.id });
  }

  desapartarInsumos() {
    this.setState({ loading: true });
    axios
      .post(
        "ventas/desapartarInsumos",
        { ventaId: this.state.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Insumos quitados de apartado");
          NotificacionMovimientosInventario(res.data.movimientosIds);
          this.consultarTodo();
        } else if (res.data.success === 1) {
          message.warn(res.data.message);
        } else {
          message.error("Sucedio un error y no se pudieron quitar de apartados los insumos");
        }
      });
  }

  abrirModalQuitarApartadoIndividual() {
    const insumos = this.formRef.current.getFieldValue('insumos') || [];
    const insumosConApartado = insumos
      .map((insumo, index) => {
        const insumoObj = this.state.todasInsumos?.find(
          (i) => i._id.toString() === insumo.insumoId?.toString()
        );
        return {
          index,
          clave: insumoObj?.claveClienteAlternativa || insumoObj?.clave || '-',
          nombre: insumoObj?.nombreClienteAlternativo || insumoObj?.nombre || insumoObj?.descripcion || 'Insumo',
          apartado: insumo.apartado || 0,
        };
      })
      .filter((i) => i.apartado > 0);
    this.setState({ modalQuitarApartadosIndividual: true, insumosParaQuitarApartado: insumosConApartado });
  }

  desapartarInsumosIndividual(selecciones) {
    this.setState({ loading: true });
    axios
      .post(
        "ventas/desapartarInsumosIndividual",
        { ventaId: this.state.id, empresaId: this.props.empresaId, selecciones },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Insumos quitados de apartado");
          NotificacionMovimientosInventario(res.data.movimientosIds);
          this.setState({ modalQuitarApartadosIndividual: false });
          this.consultarTodo();
        } else if (res.data.success === 1) {
          message.warn(res.data.message);
        } else {
          message.error("Sucedio un error y no se pudieron quitar de apartados los insumos");
        }
      });
  }

  activarQzTray = () => {
    qz.security.setCertificatePromise(function (resolve, reject) {
      //Preferred method - from server
      fetch("../cert_qz_tray.txt", { cache: 'no-store', headers: { 'Content-Type': 'text/plain' } })
        .then(function (data) { data.ok ? resolve(data.text()) : reject(data.text()); });
    })

    qz.security.setSignatureAlgorithm("SHA512"); // Since 2.1
    qz.security.setSignaturePromise(function (toSign) {
      return function (resolve, reject) {
        // Preferred method - from server

        // axios.post('/puntoVenta/signQzTray', toSign, {
        //   headers: {
        //     ...this.props.headersToken,
        //     'Content-Type': 'text/plain',
        //   }
        // })
        //   .then(response => {
        //     console.log("Firma recibida:", response.data);
        //     resolve(response.data); // ✔️ Texto plano (la firma base64)
        //   })
        //   .catch(error => {
        //     console.error('Error firmando para QZ Tray:', error);
        //     reject("No se pudo firmar el contenido");
        //   });

        fetch("../erp/api/puntoVenta/signQzTray?request=" + toSign, { cache: 'no-store', headers: { 'Content-Type': 'text/plain' } })
          .then(function (data) { data.ok ? resolve(data.text()) : reject(data.text()); });

        //Alternate method - unsigned
        // resolve(); // remove this line in live environment
      };
    });
  }

  printTicket = async (dataTicket) => {
    try {

      if (!this.props.impresoraSeleccionada) {
        throw new Error("No hay impresora seleccionada");
      }

      if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
      }

      const config = await qz.configs.create(this.props.impresoraSeleccionada ? this.props.impresoraSeleccionada : "",
        {
          encoding: 'Cp1252',
          scaleContent: false,     // No escalar el contenido del PDF
          rasterize: true,        // Evita convertir a imagen si no quieres que reduzca resolución
          density: 300             // Ajusta según tu impresora (203 o 300 dpi típico)
        }
      );


      // const data = ticketEscPos(dataTicket);
      const pdf2 = ticketPdf(dataTicket);
      const base64_1 = await new Promise((resolve) => {
        pdfMake.createPdf(pdf2).getBase64((base64) => resolve(base64));
      });

      await qz.print(config, [
        {
          type: 'pixel',
          format: 'pdf',
          flavor: 'base64',
          data: base64_1
        },
      ]);

      await qz.websocket.disconnect();
      // await qz.print(config, data);

    } catch (err) {
      console.error('Error imprimiendo ticket:', err);
      const pdf2 = ticketPdf(dataTicket);
      pdfMake.createPdf(pdf2).getBlob((blob) => {
        const pdfURL = URL.createObjectURL(blob);

        const ua = navigator.userAgent || "";
        const isAndroid = /Android/i.test(ua);

        // Chrome en iOS aparece como "CriOS"
        const isChromeiOS = /CriOS/i.test(ua);

        // WebView Android común (opcional pero útil)
        const isWebViewAndroid =
          isAndroid && /wv|Version\/\d+\.\d+.*Chrome\/\d+/i.test(ua);

        // ❌ Navegadores que NO pueden con printJS → visor directo
        if (isAndroid || isWebViewAndroid || isChromeiOS) {
          const win = window.open(pdfURL, "_blank");
          if (!win) window.location.href = pdfURL;
          setTimeout(() => URL.revokeObjectURL(pdfURL), 60000);
          return;
        }

        // ✅ Navegadores que SÍ pueden (o al menos vale la pena intentar)
        // Intentamos printJS y NO hacemos fallback si falla
        try {
          printJS({
            printable: pdfURL,
            type: "pdf",
            showModal: false,
          });
        } catch (e) {
          // Si falla de inmediato, NO hacemos nada más
          message.error("No se pudo imprimir el ticket automáticamente. Cambie de navegador (por ejemplo, Chrome o Firefox).");
          console.warn("printJS falló inmediatamente:", e);
        }

        // No revocar rápido o rompes printJS
        setTimeout(() => URL.revokeObjectURL(pdfURL), 60000);
      });
    }
  }

  cerrarModalRefacturar = () => {
    this.setState({ modalRefacturarVenta: false });
    this.consultarTodo();
  }

  refacturarVenta = (ventaId) => {
    this.setState({ modalRefacturarVenta: true, ventaIdRefacturar: ventaId });
  }

  cerrarModalFacturarQuitarGlobal = () => {
    this.setState({ modalFacturarQuitarGlobal: false });
    this.consultarTodo();
  }

  quitarVentaDeGlobal = () => {
    this.setState({ loading: true });
    axios
      .post(
        "ventas/quitarVentaDeGlobal",
        { ventaId: this.state.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Venta quitada de la factura global");
          this.consultarTodo();
        } else if (res.data.success === 1) {
          message.warn(res.data.message);
        } else {
          message.error("Sucedio un error y no se pudo quitar la venta de la factura global");
        }
      });
  }

  cerrarRastrearRequisicion() {
    this.consultarTodo();
    this.setState({
      modalRastrearRequisicion: false,
    });
  }

  cerrarVerFacturaVariasRemisiones(direccionar, id) {
    this.setState({ modalVerFacturaVariasRemisiones: false });
    if (direccionar) {
      this.setState({ id: id }, () => {
        this.consultarTodo();
      });
    }
  }

  cerrarVerRemisionesVariasFacturas(direccionar, id) {
    this.setState({ modalVerRemisionesVariasFactura: false });
    if (direccionar) {
      this.setState({ id: id }, () => {
        this.consultarTodo();
      });
    }
  }

  // Método para obtener las columnas de la tabla de insumos
  getInsumosColumns() {
    return [
      { title: "#", width: "3%" },
      { title: "Clave", width: "5%" },
      { title: "Insumo", width: "22%" },
      { title: "Unidad", width: "6%" },
      { title: "Proyecto", width: "12%" },
      { title: "PU", width: "9%" },
      { title: "Precio Neto", width: "9%" },
      {
        title: (
          <>
            <div>Cant.</div>
            <div style={{ fontWeight: 400, fontSize: '11px', color: '#868585' }}>
              Total: {this.state.totalCantidadInsumos}
            </div>
          </>
        ),
        width: "8%",
      },
      { title: "Apar.", width: "7%" },
      { title: "Desc.", width: "8%" },
      { title: "Subtotal / Impuesto / Total", width: "13%" },
      { title: "Acciones", width: "6%" }
    ];
  }

  // Método para renderizar cada fila de la tabla de insumos
  renderInsumoRow({ key, name, fieldKey, restField, arrayKey }) {
    return (
      <React.Fragment key={key}>
        <tr className="fila-insumo">
          <td className="td-border">
            <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585' }}>
              {arrayKey + 1}
            </div>
          </td>
          <td
            className="td-border"
            style={{ cursor: 'pointer' }}
            onDoubleClick={() => {
              const insumoId = this.formRef.current.getFieldValue(['insumos', arrayKey, 'insumoId']);
              const proyectoId = this.formRef.current.getFieldValue(['insumos', arrayKey, 'proyectoId']);
              const insumoObj = this.state.todasInsumos?.find(i => i._id.toString() === insumoId?.toString());
              this.abrirDisponibilidad(insumoId, insumoObj?.nombreClienteAlternativo || insumoObj?.nombre || insumoObj?.descripcion || '', proyectoId);
            }}
            onContextMenu={(e) => {
              e.preventDefault();
              const insumoId = this.formRef.current.getFieldValue(['insumos', arrayKey, 'insumoId']);
              const insumoObj = this.state.todasInsumos?.find(i => i._id.toString() === insumoId?.toString());
              this.abrirHistorialCliente(insumoId, insumoObj?.nombreClienteAlternativo || insumoObj?.nombre || insumoObj?.descripcion || '', arrayKey);
            }}
            title="Doble clic: disponibilidad · Clic derecho: historial con este cliente"
          >
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                const insumoSeleccionado = this.state.todasInsumos?.find(
                  (insumo) => insumo._id.toString() === insumoId?.toString()
                );
                return (
                  <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    {insumoSeleccionado?.claveClienteAlternativa || insumoSeleccionado?.clave || '-'}
                  </div>
                );
              }}
            </FormItem>
          </td>

          <td
            className="td-border"
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
            onDoubleClick={() => {
              const insumoId = this.formRef.current.getFieldValue(['insumos', arrayKey, 'insumoId']);
              const insumoCosteado = this.formRef.current.getFieldValue(['insumos', arrayKey, 'costeado']);
              if(!insumoCosteado){
                return;
              }
              this.setState({
                modalVisibleCorreoCosteo: true,
                modalVisibleCorreoCosteoId: insumoId,
              });
            }}
          >
            <FormItem
              {...restField}
              name={[name, "insumoId"]}
              required
              noStyle
            >
            <SelectItem
                sinBorde
                autoFocus
                dropdownMatchSelectWidth={600}
                width="100%"
                placeholder="Insumo"
                disabled
                noDisabledBackground
                esTabla
                style={{ boxShadow: 'none', height: 'auto', minHeight: '32px'}}
              >
                {this.state.objetoInsumos}
              </SelectItem>
            </FormItem>
          </td>

          <td className="td-border">
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                const insumoSeleccionado = this.state.todasInsumos?.find(
                  (insumo) => insumo._id.toString() === insumoId?.toString()
                );
                return (
                  <div style={{ fontSize: '14px', textAlign: 'center' , color: '#868585'}}>
                    {insumoSeleccionado?.unidad || '-'}
                    {insumoSeleccionado?.presentacionCliente && (
                      <div style={{ fontSize: 11, color: '#999' }}>{insumoSeleccionado.presentacionCliente}</div>
                    )}
                  </div>
                );
              }}
            </FormItem>
          </td>

          <td className="td-border">
            <FormItem
              shouldUpdate={(prev, curr) =>
                prev.proyectoId !== curr.proyectoId
              }
              noStyle
            >
              {({ getFieldValue }) => { 
                const proyectoId = getFieldValue("proyectoId");
                return (
                  <FormItem
                    {...restField}
                    name={[name, "proyectoId"]}
                    required
                    noStyle
                    initialValue={proyectoId}
                  >
                    <SelectItem
                      sinBorde
                      width="100%"
                      placeholder="Proyecto"
                      disabled
                      noDisabledBackground
                      style={{ boxShadow: 'none' }}
                    >
                      {this.state.objetoProyectos}
                    </SelectItem>
                  </FormItem>
                );
              }}
            </FormItem>
          </td>

          <td className="td-border">
            <FormItem
              {...restField} 
              name={[name, "precioUnitario"]}
              noStyle
              required
            >
              <InputNumberItem
                sinBorde
                disabled
                placeholder="Precio Unitario"
                dinero
              />
            </FormItem>
          </td>

          <td className="td-border">
            <FormItem
              {...restField}
              name={[name, "precioUnitarioConImpuestos"]}
              noStyle
              required
            >
              <InputNumberItem
                sinBorde
                disabled
                placeholder="Precio Unitario con Impuestos"
                dineroDisabled
              />
            </FormItem>
          </td>

          <td className="td-border">
            <FormItem
              {...restField}
              name={[name, "cantidad"]}
              number
              noStyle
              type="number"
            >
              <InputNumberItem
                sinBorde
                disabled
                min={0}
                max={10000000}
              />
            </FormItem>
          </td>

          <td className="td-border">
            <FormItem
              {...restField}
              name={[name, "apartado"]}
              noStyle
              required
            >
              <InputNumberItem
                sinBorde
                placeholder="Apartado"
                disabled
                min={0}
                max={10000000}
              />
            </FormItem>
          </td>

          <td className="td-border">
            {this.state.tiposDescuento[arrayKey] === "cantidad" ? (
              <FormItem
                {...restField}
                key={`desc-cantidad-${arrayKey}`}
                name={[name, "descuentoCantidad"]}
                numberCero
                noStyle
                initialValue={0}
              >
                <InputNumberItem
                  disabled
                  sinBorde
                  placeholder="Desc. $"
                  dinero
                  onDoubleClick={() => this.onDobleClickDescuento(arrayKey)}
                  onChange={(value) =>
                    this.onChangePrecioCantidadDescuento(value, arrayKey)
                  }
                />
              </FormItem>
            ) : (
              <FormItem
                {...restField}
                key={`desc-porcentaje-${arrayKey}`}
                name={[name, "descuento"]}
                required
                numberCero
                noStyle
                initialValue={0}
              >
                <InputNumberItem
                  disabled
                  sinBorde
                  placeholder="Desc. %"
                  porcentaje
                  max={100}
                  onDoubleClick={() => this.onDobleClickDescuento(arrayKey)}
                  onChange={(value) =>
                    this.onChangePrecioCantidadDescuento(value, arrayKey)
                  }
                />
              </FormItem>
            )}
          </td>


          <td className="td-border">
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const subtotal = getFieldValue(['insumos', arrayKey, 'subtotal']) || 0;
                const impuestos = getFieldValue(['insumos', arrayKey, 'impuestos']) || 0;
                const total = getFieldValue(['insumos', arrayKey, 'total']) || 0;

                return (
                  <div className="celda-totales" style={{ fontSize: '12px' }}>
                    <div>{dineroDisabledMask(subtotal)}</div>
                    <div>{dineroDisabledMask(impuestos)}</div>
                    <div className="total-bold">Total: {dineroDisabledMask(total)}</div>
                  </div>
                );
              }}
            </FormItem>

            {/* Campos hidden para mantener los valores en el form */}
            <FormItem {...restField} name={[name, "subtotal"]} hidden>
              <InputNumberItem />
            </FormItem>
            <FormItem {...restField} name={[name, "impuestos"]} hidden>
              <InputNumberItem />
            </FormItem>
            <FormItem {...restField} name={[name, "total"]} hidden>
              <InputNumberItem />
            </FormItem>
          </td>

          <td className="td-border">
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                const insumoSeleccionado = this.state.todasInsumos?.find(
                  (insumo) => insumo._id.toString() === insumoId?.toString()
                );
                const entregado = getFieldValue(['insumos', arrayKey, 'entregado']);
                const puedeCambiarInsumo =
                  this.props.permitirCambiarInsumoVenta &&
                  this.props.permisoCambiarInsumoVenta &&
                  this.state.estado !== 0 &&
                  insumoSeleccionado?.inventariable &&
                  entregado > 0;
                const componentesKit = getFieldValue(['insumos', arrayKey, 'componentesKit']);
                const iconos = [];
                if (insumoId) {
                  iconos.push(
                    <EyeOutlined
                      key="detalle"
                      title="Ver detalle del insumo"
                      style={{ cursor: 'pointer', fontSize: '16px', color: '#00BFD6' }}
                      onClick={() =>
                        this.abrirDetalleInsumo(
                          insumoId,
                          insumoSeleccionado?.nombre || insumoSeleccionado?.descripcion || ''
                        )
                      }
                    />
                  );
                }
                if (puedeCambiarInsumo) {
                  const insumoVentaId = getFieldValue(['insumos', arrayKey, '_id']);
                  const proyectoId = getFieldValue(['insumos', arrayKey, 'proyectoId']);
                  iconos.push(
                    <SwapOutlined
                      key="cambiar"
                      title="Cambiar Insumo"
                      style={{ cursor: 'pointer', fontSize: '16px', color: '#800080' }}
                      onClick={() =>
                        this.abrirModalCambiarInsumo(insumoVentaId, insumoId, proyectoId, entregado)
                      }
                    />
                  );
                }
                if (componentesKit?.length > 0) {
                  iconos.push(
                    <BuildOutlined
                      key="kit"
                      title="Insumos Del Kit"
                      style={{ cursor: 'pointer', fontSize: '16px', color: '#fa8c16' }}
                      onClick={() => this.abrirComponentesKit(arrayKey)}
                    />
                  );
                }
                if (iconos.length === 0) return null;
                return (
                  <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
                    {iconos}
                  </div>
                );
              }}
            </FormItem>
          </td>
        </tr>

        {/* Fila de Leyenda */}
        <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos && curr.insumos && prev.insumos[arrayKey]?.leyenda !== curr.insumos[arrayKey]?.leyenda}>
          {({ getFieldValue }) => {
            let arrayValue = getFieldValue("insumos");
            if (arrayValue && arrayValue[arrayKey]?.leyenda) {
              return (
                <tr className="fila-leyenda">
                  <td colSpan="12" className="td-border">
                    <div className="contenedor-leyenda">
                      <div className="texto-leyenda">
                        <b>Leyenda:</b> {arrayValue[arrayKey].leyenda}
                      </div>
                    </div>
                  </td>
                </tr>
              );
            }
          }}
        </FormItem>


        {/* Fila de Observaciones */}
        <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos && curr.insumos && (prev.insumos[arrayKey]?.observaciones !== curr.insumos[arrayKey]?.observaciones || prev.insumos[arrayKey]?.observacionesXml !== curr.insumos[arrayKey]?.observacionesXml)}>
          {({ getFieldValue }) => {
            let arrayValue = getFieldValue("insumos");
            if (arrayValue && arrayValue[arrayKey]?.observaciones) {
              return (
                <tr className="fila-observaciones">
                  <td colSpan="12" className="td-border">
                    <div className={`contenedor-observaciones ${arrayValue[arrayKey].observacionesXml ? 'con-xml' : 'sin-xml'}`}>
                      <div className="texto-observaciones">
                        {String(arrayValue[arrayKey].observaciones)
                          .split(/\r?\n/)
                          .map((line, i) => <span key={i}>{line}<br /></span>)}
                      </div>
                    </div>
                  </td>
                </tr>
              );
            }
          }}
        </FormItem>

        {/* Fila de Insumos del Kit */}
        <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos && curr.insumos && prev.insumos[arrayKey]?.componentesKit !== curr.insumos[arrayKey]?.componentesKit}>
          {({ getFieldValue }) => {
            let arrayValue = getFieldValue("insumos");
            const componentesKit = arrayValue?.[arrayKey]?.componentesKit;
            if (componentesKit && componentesKit.length > 0) {
              return (
                <tr className="fila-observaciones">
                  <td colSpan="12" className="td-border">
                    <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'left' }}>
                      <div style={{ width: '100%', textAlign: 'left', color: "#005661" }}>
                        <b>Insumos del kit:</b> {componentesKit.map(valueComponente => `${valueComponente.descripcion || '-'} (x${valueComponente.cantidad})`).join(", ")}
                      </div>
                    </div>
                  </td>
                </tr>
              );
            }
          }}
        </FormItem>

      </React.Fragment>
    );
  }

  renderInsumosAnterioresContent() {
    const insumosAnteriores = this.state.insumosAnteriores || [];

    return (
      <table className="table" style={{ width: "100%" }}>
        <thead>
          <tr>
            <th className="th-border" style={{ padding: 6 }}>Insumo</th>
            <th className="th-border" style={{ padding: 6, width: "12%" }}>Cantidad</th>
            <th className="th-border" style={{ padding: 6, width: "20%" }}>Fecha</th>
            <th className="th-border" style={{ padding: 6, width: "20%" }}>Venta Destino</th>
            <th className="th-border" style={{ padding: 6, width: "15%" }}>Estado</th>
          </tr>
        </thead>
        <tbody>
          {insumosAnteriores.map((valueAnterior, index) => {
            const ventaDestino = (this.state.ventasDerivadas || []).find(
              (valueVenta) => valueVenta._id.toString() === valueAnterior.ventaDestinoId?.toString()
            );
            const folioDestino = ventaDestino
              ? (ventaDestino.remisionSerie || 'R') + ' - ' + ventaDestino.remisionNumero + (ventaDestino.sufijoPartida ? (' ' + ventaDestino.sufijoPartida) : '')
              : 'N/D';
            const estadoTexto = ventaDestino?.facturaId ? 'Ya facturado' : 'Dividido';

            return (
              <tr key={index}>
                <td className="td-border" style={{ padding: 6 }}>
                  {valueAnterior.clave ? valueAnterior.clave + " - " : ""}
                  {valueAnterior.descripcion || "Insumo"}
                </td>
                <td className="td-border" style={{ padding: 6, textAlign: "center" }}>{valueAnterior.cantidad}</td>
                <td className="td-border" style={{ padding: 6, textAlign: "center" }}>
                  {valueAnterior.fecha ? moment(valueAnterior.fecha).format("DD/MM/YYYY HH:mm") : ""}
                </td>
                <td className="td-border" style={{ padding: 6, textAlign: "center" }}>
                  {ventaDestino ? (
                    <Button
                      type="link"
                      style={{ padding: 0, height: "auto" }}
                      onClick={() => this.props.history.push('/panel/verVenta', { id: valueAnterior.ventaDestinoId })}
                    >
                      {folioDestino}
                    </Button>
                  ) : folioDestino}
                </td>
                <td className="td-border" style={{ padding: 6, textAlign: "center" }}>{estadoTexto}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  // Método para renderizar el contenido del tab Entrega
  renderEntregaContent() {
    // Obtener los datos de la dirección de entrega del formulario
    const direccionEntrega = this.formRef.current?.getFieldValue("direccionEntrega");
    const clienteDireccion = this.state.direccionesCliente && this.state.direccionesCliente[0];

    return (
      <TabEntregaDireccion
        direccionEntrega={direccionEntrega}
        clienteDireccion={clienteDireccion}
        loadingEntrega={this.state.loadingEntrega}
        readOnly={true}
        editableFields={['referencia', 'destino']}
        formInstance={this.formRef.current}
        objetoMunicipios={this.state.objetoMunicipios}
        objetoEstados={this.state.objetoEstados}
        objetoPaises={this.state.objetoPaises}
        objetoPlantasEntrega={this.state.objetoPlantasEntrega}
      />
    );
  }

  // Método para generar la configuración de observaciones y totales
  getObservacionesConfig() {
    return {
      observaciones: {
        label: "Observaciones",
        value: this.formRef.current?.getFieldValue("observaciones"),
        onSave: (newValue) => {
          // Actualización optimista - actualizar UI inmediatamente
          this.formRef.current?.setFieldsValue({ observaciones: newValue });
          this.forceUpdate(); // Forzar re-render inmediato

          // Guardar en backend en segundo plano
          axios
            .post("ventas/editarObservaciones", {
              ventaId: this.state.id,
              empresaId: this.props.empresaId,
              observaciones: newValue,
            }, { headers: this.props.headersToken })
            .then((res) => {
              if (res.data.success !== 2) {
                message.warning("Error al guardar observaciones");
              } else {
                message.success("Observaciones actualizadas");
              }
            })
            .catch(() => {
              message.error("Error al guardar observaciones");
            });
        }
      },
      observaciones2: {
        label: "Observaciones Internas",
        value: this.formRef.current?.getFieldValue("observaciones2"),
        tooltip: "Estas observaciones no se imprimirán en la venta.",
        onSave: (newValue) => {
          // Actualización optimista 
          this.formRef.current?.setFieldsValue({ observaciones2: newValue });
          this.forceUpdate(); // Forzar re-render 

          // Guardar en backend en segundo plano
          axios
            .post("ventas/editarObservaciones2", {
              ventaId: this.state.id,
              empresaId: this.props.empresaId,
              observaciones2: newValue,
            }, { headers: this.props.headersToken })
            .then((res) => {
              if (res.data.success !== 2) {
                message.warning("Error al guardar observaciones internas");
              } else {
                message.success("Observaciones internas actualizadas");
              }
            })
            .catch(() => {
              message.error("Error al guardar observaciones internas");
            });
        }
      },
      camposCondicionales: this.renderCamposCondicionales(),
      camposFechas: this.renderCamposFechas(),
      checkboxes: this.getCheckboxesConfig(),
      totales: (
        <table className="table" style={{ marginTop: 0, fontSize: "16px" }}>
          <tbody>
            <tr>
              <th className="th-totales" style={{ width: "50%", fontSize: "16px" }}>
                Total Insumos
              </th>
              <td className="td-totales-right" style={{ width: "50%", fontSize: "16px" }}>
                {this.state.totalCantidadInsumos}
              </td>
            </tr>
          </tbody>

          <tbody>
            <tr>
              <th className="th-totales" style={{ width: "50%", fontSize: "16px" }}>
                Subtotal
              </th>
              <td className="td-totales-right" style={{ width: "50%", fontSize: "16px" }}>
                {dineroDisabledMask(this.state.subtotal)}
              </td>
            </tr>
          </tbody>

          {this.state.arrayImpuestos?.map((impuesto, index) => (
            <tbody key={index}>
              <tr>
                <th className="th-totales" style={{ fontSize: "16px" }}>{impuesto.descripcionFactura}</th>
                <td className="td-totales-right" style={{ fontSize: "16px" }}>{dineroDisabledMask(impuesto.totalImpuestos)}</td>
              </tr>
            </tbody>
          ))}

          <tbody>
            <tr>
              <th className="th-totales" style={{ fontSize: "16px" }}>Total</th>
              <td className="td-totales-right" style={{ fontSize: "16px" }}>
                {dineroDisabledMask(this.state.total)}
              </td>
            </tr>
          </tbody>

          {this.state.arrayRetenciones?.map((retencion, index) => (
            <tbody key={index}>
              <tr>
                <th className="th-totales" style={{ fontSize: "18px" }}>{retencion.descripcionFactura}</th>
                <td className="td-totales-right" style={{ fontSize: "18px" }}>{dineroDisabledMask(retencion.totalRetenciones)}</td>
              </tr>
            </tbody>
          ))}

          <tbody>
            <tr>
              <th className="th-totales" style={{ fontSize: "17px" }}>Total a Pagar</th>
              <td className="td-totales-right" style={{ fontSize: "17px" }}>
                {dineroDisabledMask(this.state.totalPagar)}
              </td>
            </tr>
          </tbody>
        </table>
      )
    };
  }

  // Método para renderizar campos condicionales
  renderCamposCondicionales() {
    if (this.props.empresaId.toString() !== '677c1e57f38e06c3032974fb') {
      return null;
    }

    return (
      <>
          <FormItem pattern margin name='articulo' label='Articulo'>
            <InputItem
              onBlur={(e) => {
                axios.post("ventas/editarConceptosF", {
                  ventaId: this.state.id,
                  empresaId: this.props.empresaId,
                  articulo: e.target.value,
                }).then((res) => {
                  if (res.data.success !== 2) {
                    message.info("La venta no se edito");
                  }
                });
              }}
            />
          </FormItem>
          <FormItem pattern margin name='diaPago' label='Dia Pago'>
            <InputItem
              onBlur={(e) => {
                axios.post("ventas/editarConceptosF", {
                  ventaId: this.state.id,
                  empresaId: this.props.empresaId,
                  diaPago: e.target.value,
                }).then((res) => {
                  if (res.data.success !== 2) {
                    message.info("La venta no se edito");
                  }
                });
              }}
            />
          </FormItem>
          <FormItem pattern margin name='concepto' label='Concepto'>
            <InputItem
              onBlur={(e) => {
                axios.post("ventas/editarConceptosF", {
                  ventaId: this.state.id,
                  empresaId: this.props.empresaId,
                  concepto: e.target.value,
                }).then((res) => {
                  if (res.data.success !== 2) {
                    message.info("La venta no se edito");
                  }
                });
              }}
            />
          </FormItem>
          <FormItem pattern margin name='pagoSemana' label='Pago Semana'>
            <InputNumberItem dinero
              onBlur={(e) => {
                axios.post("ventas/editarConceptosF", {
                  ventaId: this.state.id,
                  empresaId: this.props.empresaId,
                  pagoSemana: Number(e.target.value.replace(/\$\s?|(,*)/g, '')),
                }).then((res) => {
                  if (res.data.success !== 2) {
                    message.info("La venta no se edito");
                  }
                });
              }}
            />
          </FormItem>
          <FormItem pattern margin name='recargoSemana' label='Recargo Semana'>
            <InputNumberItem dinero
              onBlur={(e) => {
                axios.post("ventas/editarConceptosF", {
                  ventaId: this.state.id,
                  empresaId: this.props.empresaId,
                  recargoSemana: Number(e.target.value.replace(/\$\s?|(,*)/g, '')),
                }).then((res) => {
                  if (res.data.success !== 2) {
                    message.info("La venta no se edito");
                  }
                });
              }}
            />
          </FormItem>
          <FormItem pattern margin name='parcialidadVigente' label='Parcialidad Vigente'>
            <InputNumberItem
              onBlur={(e) => {
                axios.post("ventas/editarConceptosF", {
                  ventaId: this.state.id,
                  empresaId: this.props.empresaId,
                  parcialidadVigente: e.target.value,
                }).then((res) => {
                  if (res.data.success !== 2) {
                    message.info("La venta no se edito");
                  }
                });
              }}
            />
          </FormItem>
          <FormItem pattern margin name='parcialidades' label='Parcialidades'>
            <InputNumberItem
              onBlur={(e) => {
                axios.post("ventas/editarConceptosF", {
                  ventaId: this.state.id,
                  empresaId: this.props.empresaId,
                  parcialidades: e.target.value,
                }).then((res) => {
                  if (res.data.success !== 2) {
                    message.info("La venta no se edito");
                  }
                });
              }}
            />
          </FormItem>
      </>
    );
  }

  // Método para renderizar campos de fechas
  renderCamposFechas() {
    return (
      <>
        <FormItem label="Fecha probable Pago" name="fechaPago" required margin>
          <DatePickerItem
            placeholder="Fecha probable Pago"
            allowClear={false}
            disabled
          />
        </FormItem>
        <FormItem label="Fecha Vencimiento" name="fechaVencimiento" required margin>
          <DatePickerItem
            placeholder="Fecha Vencimiento"
            allowClear={false}
            disabled
          />
        </FormItem>
      </>
    );
  }

  // Método para obtener configuración de checkboxes
  getCheckboxesConfig() {
    const checkboxes = [];

    if (this.props.activarPagare) {
      checkboxes.push({
        label: "Pagaré",
        name: "imprimirPagare",
        onChange: (e) => {
          axios.post("ventas/editarImprimirPagare", {
            ventaId: this.state.id,
            empresaId: this.props.empresaId,
            imprimirPagare: e.target.checked,
          }).then((res) => {
            if (res.data.success !== 2) {
              message.info("La venta no se edito");
            }
          });
        }
      });
    }

    if (this.props.quitarImpuestosOpcionalVentas) {
      checkboxes.push({
        label: "Quitar Impuestos",
        name: "quitarImpuestos",
        onChange: (e) => {
          axios.post("ventas/editarQuitarImpuestos", {
            ventaId: this.state.id,
            empresaId: this.props.empresaId,
            quitarImpuestos: e.target.checked,
          }).then((res) => {
            if (res.data.success !== 2) {
              message.info("La venta no se edito");
            }
          });
        }
      });
    }

    checkboxes.push({
      label: "Imprimir",
      name: "imprimirObservaciones",
      onChange: (e) => {
        axios.post("ventas/editarImprimirObservaciones", {
          ventaId: this.state.id,
          empresaId: this.props.empresaId,
          imprimirObservaciones: e.target.checked,
        }).then((res) => {
          if (res.data.success !== 2) {
            message.info("La venta no se edito");
          }
        });
      }
    });

    checkboxes.push({
      label: "Des. Imprimir Banco",
      name: "deshabilitarBanco",
      onChange: (e) => {
        axios.post("ventas/editarDeshabilitarBanco", {
          ventaId: this.state.id,
          empresaId: this.props.empresaId,
          deshabilitarBanco: e.target.checked,
        }).then((res) => {
          if (res.data.success !== 2) {
            message.info("La venta no se edito");
          }
        });
      }
    });

    return checkboxes;
  }

  getEnvioOnlineColumns() {
    return [
      { title: "Origen", width: "12%" },
      { title: "Paquetería", width: "12%" },
      { title: "Servicio", width: "15%" },
      { title: "Tiempo Est.", width: "12%" },
      { title: "Costo Guía", width: "10%" },
      { title: "Cobro Cliente", width: "10%" },
      { title: "Estado", width: "14%" },
      { title: "Rastreo / Acciones", width: "15%" }
    ];
  }

  renderEnvioOnlineRow({ key, name, fieldKey, restField, arrayKey }) {
    return (
      <React.Fragment key={key}>
        <tr className="fila-insumo">
          
          <td className="td-border" style={{ textAlign: 'center' }}>
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const origen = getFieldValue(['cotizacionesEnvioOnline', arrayKey, 'origen']);
                return <div style={{ fontSize: '14px', color: '#595959' }}>{this.etiquetaOrigenEnvio(origen)}</div>;
              }}
            </FormItem>
          </td>

          <td className="td-border" style={{ textAlign: 'center' }}>
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const origen = getFieldValue(['cotizacionesEnvioOnline', arrayKey, 'origen']);
                const carrier = getFieldValue(['cotizacionesEnvioOnline', arrayKey, 'carrier']);
                if (origen === 'entrega_sucursal') {
                  return <div style={{ fontSize: '14px', color: '#595959' }}>—</div>;
                }
                return <div style={{ fontSize: '14px', color: '#595959' }}>{carrier?.toUpperCase()}</div>;
              }}
            </FormItem>
          </td>

          <td className="td-border" style={{ textAlign: 'center' }}>
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const origen = getFieldValue(['cotizacionesEnvioOnline', arrayKey, 'origen']);
                const service = getFieldValue(['cotizacionesEnvioOnline', arrayKey, 'service']);
                if (origen === 'entrega_sucursal') {
                  const branchLabel = this.state.cotizacionesEnvioOnline?.[arrayKey]?.pickupBranch?.label;
                  return <div style={{ fontSize: '14px', color: '#595959' }}>{branchLabel || service || 'Recoger en sucursal'}</div>;
                }
                return <div style={{ fontSize: '14px', color: '#595959' }}>{service}</div>;
              }}
            </FormItem>
          </td>

          <td className="td-border" style={{ textAlign: 'center' }}>
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const origen = getFieldValue(['cotizacionesEnvioOnline', arrayKey, 'origen']);
                if (origen === 'entrega_sucursal') {
                  return <div style={{ fontSize: '14px', color: '#595959' }}>—</div>;
                }
                const tiempo = getFieldValue(['cotizacionesEnvioOnline', arrayKey, 'tiempoEstimado']);
                return <div style={{ fontSize: '14px', color: '#595959' }}>{tiempo || 'N/A'}</div>;
              }}
            </FormItem>
          </td>

          <td className="td-border" style={{ textAlign: 'center' }}>
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const origen = getFieldValue(['cotizacionesEnvioOnline', arrayKey, 'origen']);
                if (origen === 'entrega_sucursal') {
                  return <div style={{ fontSize: '14px', color: '#595959' }}>—</div>;
                }
                const costoApi = getFieldValue(['cotizacionesEnvioOnline', arrayKey, 'costoApi']);
                return <div style={{ fontSize: '14px', color: '#595959' }}>{dineroDisabledMask(costoApi)}</div>;
              }}
            </FormItem>
          </td>

          <td className="td-border" style={{ textAlign: 'center' }}>
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const origen = getFieldValue(['cotizacionesEnvioOnline', arrayKey, 'origen']);
                if (origen === 'entrega_sucursal') {
                  return <div style={{ fontSize: '14px', color: '#595959' }}>—</div>;
                }
                const costoCliente = getFieldValue(['cotizacionesEnvioOnline', arrayKey, 'costoCliente']);
                return <div style={{ fontSize: '14px', color: '#595959' }}>{dineroDisabledMask(costoCliente)}</div>;
              }}
            </FormItem>
          </td>

          <td className="td-border" style={{ textAlign: 'center' }}>
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const estado = getFieldValue(['cotizacionesEnvioOnline', arrayKey, 'estadoPaquete']) || 0;
                const estadosPaquete = {
                  0: { text: "Creado", color: "#8c8c8c" },
                  1: { text: "Pagado", color: "#faad14" },
                  2: { text: "Empaquetado", color: "#13c2c2" },
                  3: { text: "Orden Recolección", color: "#722ed1" },
                  4: { text: "En Tránsito", color: "#1890ff" },
                  5: { text: "Entregado", color: "#52c41a" }
                };
                const estadoActual = estadosPaquete[estado];

                return (
                  <span style={{ 
                    backgroundColor: estadoActual.color + '20', 
                    color: estadoActual.color, 
                    padding: '4px 8px', 
                    borderRadius: '4px', 
                    fontWeight: 'bold',
                    fontSize: '12px'
                  }}>
                    {estadoActual.text}
                  </span>
                );
              }}
            </FormItem>
          </td>

          <td className="td-border" style={{ textAlign: 'center' }}>
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const envio = this.state.cotizacionesEnvioOnline[arrayKey] || {};
                if (envio.origen === 'entrega_sucursal') {
                  const b = envio.pickupBranch || {};
                  const linea1 = [b.calle, b.numeroExterior].filter(Boolean).join(' ');
                  const linea2 = [b.colonia, b.municipio, b.estado].filter(Boolean).join(', ');
                  const cp = b.cp ? `CP ${b.cp}` : '';
                  return (
                    <div style={{ padding: '4px 6px', fontSize: '12px', color: '#595959', textAlign: 'left' }}>
                      {b.label && <div style={{ fontWeight: 'bold', marginBottom: 2 }}>{b.label}</div>}
                      {linea1 && <div>{linea1}{b.numeroInterior ? ` Int. ${b.numeroInterior}` : ''}</div>}
                      {linea2 && <div>{linea2}</div>}
                      {cp && <div>{cp}</div>}
                      {!b.calle && !b.label && (
                        <div style={{ color: '#8c8c8c' }}>Sin sucursal registrada</div>
                      )}
                    </div>
                  );
                }

                if (envio.guiaGenerada || envio.trackingNumber) {
                  return (
                    <div style={{ padding: '8px 0' }}>
                      <a href={envio.labelUrl || "#"} target="_blank" rel="noopener noreferrer" style={{ color: '#1890ff', fontWeight: 'bold' }}>
                        <CarOutlined style={{marginRight: 4}}/>
                        {envio.trackingNumber || 'Ver PDF'}
                      </a>
                    </div>
                  );
                }

                if (this.state.estado !== 0 && this.state.estado !== 5) {
                  const labelBoton = envio.origen === 'envio_manual'
                    ? 'Cargar / Generar Guía'
                    : envio.origen === 'dropshipping_urrea'
                      ? 'Generar OC Dropshipping'
                      : 'Generar Guía';
                  return (
                    <ButtonItem
                      type="primary"
                      size="small"
                      verde
                      icon={<RocketOutlined />}
                      onClick={() => this.abrirModalEnvio(envio.origen)}
                    >
                      {labelBoton}
                    </ButtonItem>
                  );
                }

                return <div style={{ color: '#8c8c8c', padding: '8px 0', fontSize: '14px' }}>Pendiente</div>;
              }}
            </FormItem>
          </td>

        </tr>
      </React.Fragment>
    );
  }

  render() {
    //const isMobile = window.innerWidth <= 1000;
    return (
      <>

        <PageHeader
          onBack={this.atras.bind(this)}
          title={`Ver Venta ( ${this.state.nombreFactura} )`}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
            padding: "10px 12px",
            fontSize: "12px",
          }}
          extra={(
            <TrazabilidadSteps trace={this.state.trace} />
          )}
        />

        <div className="card-background" style={{ paddingTop: 0 }}>
          <Spin
            spinning={this.state.loading}
            style={{ display: "block", margin: "0 0 0 auto" }}
          >
            <Form
              key={this.state.id}
              ref={this.formRef}
              name="verVenta"
              layout
            >
              <VentasForm // Componente de Formulario de Ventas
                    // Header
                    codigo={this.state.nombreFactura}
                    fecha={this.formRef.current?.getFieldValue("fechaVenta") || moment()}
                    onFechaChange={null}
                    fechaDisabled={true}
                    showFecha={true}

                    
                    datosGeneralesContent={(
                      <>
                        {/* Fila 1: Cliente y Vendedor */}
                         <Row gutter={[16, 8]} align="middle">
                            <Col xs={24} sm={24} md={14} lg={14} ref={this.refCliente}>
                                <FormItem
                                  label="Cliente"
                                  name="clienteId"
                                  required
                                  margin
                                  labelCol={{ span: 4 }}
                                  wrapperCol={{ span: 20 }}
                                >
                                  <SelectItem disabled noDisabledBackground>
                                    {this.state.objetoClientes}
                                  </SelectItem>
                                </FormItem>
                          </Col>

                          {/* Fecha */}
                          <Col xs={12} sm={12} md={10} lg={10}>
                            <FormItem
                              label="Fecha:"
                              name="fechaVenta"
                              required
                              margin
                              initialValue={moment()}
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 14 }}
                            >
                              <DatePickerItem disabled allowClear={false} />
                            </FormItem>
                          </Col>
                        </Row>

                        {/* ROW 2 */}
                        <Row gutter={[16, 8]}>
                          <Col xs={24} sm={24} md={14} lg={14}>
                              <FormItem
                                label="Vendedor"
                                name="vendedorId"
                                required
                                margin
                                labelCol={{ span: 4 }}
                                wrapperCol={{ span: 20 }}
                              >
                                <SelectItem disabled noDisabledBackground>
                                  {this.state.objetoUsuarios}
                                </SelectItem>
                              </FormItem>
                          </Col>

                          {/* Tipo */}
                          <Col xs={12} sm={12} md={10} lg={10} ref={this.refFactura}>
                            <FormItem
                              name="factura"
                              label="Tipo"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 10 }}
                              initialValue={2}
                              margin
                            >
                              <SelectItem disabled noDisabledBackground>
                                <Option value={1}>Factura</Option>
                                <Option value={2}>Remisión</Option>
                                <Option value={3}>No Contable</Option>
                              </SelectItem>
                            </FormItem>
                          </Col>
                        </Row>

                        {/* ROW 3 */}
                        <Row gutter={[16, 8]}>
                          {/* Canal */}
                          <Col xs={24} sm={24} md={14} lg={14}>
                              <FormItem
                                label="Canal"
                                name="canalDeVentaId"
                                labelCol={{ span: 4 }}
                                wrapperCol={{ span: 20 }}
                                margin
                              >
                                <SelectItem onChange={this.editarCanalVenta.bind(this)}>
                                  {this.state.objetoCanalesVenta}
                                </SelectItem>
                              </FormItem>
                          </Col>

                          {/* Método */}
                          <Col xs={12} sm={12} md={10} lg={10} ref={this.refContado}>
                            <FormItem
                              label="Método"
                              name="contado"
                              initialValue={1}
                              required
                              margin
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 10 }}
                            >
                              <SelectItem disabled noDisabledBackground>
                                <Option value={1}>Contado - PUE</Option>
                                <Option value={2}>Crédito - PPD</Option>
                              </SelectItem>
                            </FormItem>
                          </Col>
                        </Row>
                        </>
                    )}

                    datosVentaContent={
                      <FormItem
                          noStyle
                          shouldUpdate={(prev, curr) =>
                              prev.insumos?.length !== curr.insumos?.length ||
                              prev.factura !== curr.factura
                          }
                      >
                          {({ getFieldValue }) => {
                              return (
                                  <>
                                  {/* Precio */}
                                    <Col xs={24} sm={24} md={24} lg={24}>                       
                                        <FormItem
                                          name="precioId"
                                          label="Precio"
                                          margin
                                          required
                                          labelCol={{ span: 7 }}
                                          wrapperCol={{ span: 14 }}
                                        >
                                          <SelectItem placeholder="Precio" disabled noDisabledBackground>
                                            {this.state.objetoPrecios}
                                          </SelectItem>
                                        </FormItem>
                                    </Col>

                                    {/* Proyecto */}
                                    <Col xs={24} sm={24} md={24} lg={24}>
                                        <FormItem
                                          name="proyectoId"
                                          label="Proyecto"
                                          required
                                          margin
                                          labelCol={{ span: 7 }}
                                          wrapperCol={{ span: 14 }}
                                        >
                                          <SelectItem placeholder="Proyecto" disabled noDisabledBackground>
                                            {this.state.objetoProyectos}
                                          </SelectItem>
                                        </FormItem>
                                    </Col>
                                                        
                                  </>
                              );
                          }}
                      </FormItem>
                  }
                    

                    datosClienteContent={(
                      <>
                        <Row gutter={[16, 8]}>
                          <Col span={24}>
                            <FormItem
                              name="ordenDeCompra"
                              label="O Compra"
                              margin
                              pattern
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16}}
                              tooltip={"Si escribe se editara automaticamente"}
                            >
                              <InputItem
                                placeholder="Orden de Compra"
                                suffix={<EditOutlined style={{ color: '#1E88E5' }} />}
                                onChange={(e) => {
                                  axios
                                    .post("ventas/editarOrdenDeCompra", {
                                      ventaId: this.state.id,
                                      empresaId: this.props.empresaId,
                                      ordenDeCompra: e.target.value,
                                    })
                                    .then((res) => {
                                      if (res.data.success !== 2) {
                                        message.info("La venta no se edito");
                                      }
                                    });
                                }}
                              />
                            </FormItem>
                          </Col>

                          <Col span={24}>
                            <FormItem
                              name="req"
                              label="Req"
                              margin
                              pattern
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                            >
                              <InputItem
                                placeholder="Requisición"
                                suffix={<EditOutlined style={{ color: '#1E88E5' }} />}
                                onChange={(e) => {
                                  axios
                                    .post("ventas/editarReq", {
                                      ventaId: this.state.id,
                                      empresaId: this.props.empresaId,
                                      req: e.target.value,
                                    })
                                    .then((res) => {
                                      if (res.data.success !== 2) {
                                        message.info("La venta no se edito");
                                      }
                                    });
                                }}
                              />
                            </FormItem>
                          </Col>

                          <Col span={24}>
                            <FormItem
                              pattern
                              name='atencion'
                              label='Atención a'
                              margin
                              tooltip="Indica a quién dirigir este documento."
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                            >
                              <InputItem
                              suffix={<EditOutlined style={{ color: '#1E88E5' }} />}
                                onChange={(e) => {
                                  axios
                                    .post("ventas/editarAtencion", {
                                      ventaId: this.state.id,
                                      empresaId: this.props.empresaId,
                                      atencion: e.target.value,
                                    })
                                    .then((res) => {
                                      if (res.data.success !== 2) {
                                        message.info("La venta no se edito");
                                      }
                                    });
                                }}
                              />
                            </FormItem>
                          </Col>
                        </Row>
                      </>
                    )}

                    extrasContent={(
                      <Row gutter={[16, 8]}>
                        <Col span={24}>
                          <FormItem
                            name="fechaEntregaEstimada"
                            label="F. Entrega Est."
                            margin
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <DatePickerItem disabled placeholder="Fecha de entrega estimada" />
                          </FormItem>
                        </Col>
                      </Row>
                    )}

                    doctorContent={
                      this.props.equipoMedico ? (
                        <>
                          <Row gutter={[8, 8]}>
                            <Col xs={24} sm={12} md={24} lg={24} span={24}>
                              <FormItem
                                 name="doctorId"
                                  label="Doctor:"
                                  labelCol={{ span: 8 }}
                                  wrapperCol={{ span: 14 }}
                                  margin
                              >
                                <SelectItem disabled noDisabledBackground placeholder="Doctor">
                                  {this.state.objetoDoctores}
                                </SelectItem>
                              </FormItem>
                            </Col>
                            <Col xs={24} sm={12} md={24} lg={24} span={24}>
                              <FormItem
                                name="pacienteId"
                                label="Paciente:"
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 14 }}
                                margin
                              >
                                <SelectItem disabled noDisabledBackground placeholder="Paciente">
                                  {this.state.objetoPacientes}
                                </SelectItem>
                              </FormItem>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} span={24}>
                              <FormItem
                                name="cirugiaId"
                                label="Cirugía:"
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 14 }}
                                margin
                              >
                                <SelectItem disabled noDisabledBackground placeholder="Cirugia">
                                  {this.state.objetoCirugias}
                                </SelectItem>
                              </FormItem>
                            </Col>
                          </Row>
                        </>
                      ) : null
                    }
                    showFormaDePago={true}
                    formaDePagoContent={( 
                     <>
                        {(() => {
                          // Acceder directamente al formulario
                          const contado = this.formRef.current?.getFieldValue("contado"); 
                          const factura = this.formRef.current?.getFieldValue("factura");
                          const cuentasXC = this.formRef.current?.getFieldValue("cuentasXC");

                          return (
                            <Row gutter={[6, 4]}>
                              {/* Forma de Pago */}
                              <Col span={24}>
                                <FormItem
                                  name="formaDePagoId"
                                  label="F Pago"
                                  initialValue="6125149afe07662acc100d58"
                                  required
                                  margin
                                  labelCol={{ span: 8 }}
                                  wrapperCol={{ span: 14 }}
                                >
                                  <SelectItem
                                    disabled
                                    noDisabledBackground
                                    placeholder="Forma de Pago"
                                  >
                                    {this.state.objetoFormasDePago}
                                  </SelectItem>
                                </FormItem>
                              </Col>

                              {/* Uso CFDI */}
                              {factura === 1 && (
                                <Col span={24}>
                                  <FormItem
                                    name="usoDeCfdiId"
                                    label="Uso CFDI"
                                    required
                                    margin
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 14 }}
                                  >
                                    <SelectItem
                                      disabled
                                      noDisabledBackground
                                      placeholder="Uso de CFDI"
                                    >
                                      {this.state.objetoUsosDeCFDI}
                                    </SelectItem>
                                  </FormItem>
                                </Col>
                              )}

                            {/* Días de crédito */}
                            {contado !== 1 && (
                              <Col span={24}>
                                <FormItem
                                  label="Días de crédito"
                                  name="diasCredito"
                                  numberCero
                                  margin
                                  required
                                  initialValue={0}
                                  labelCol={{ span: 8 }}
                                  wrapperCol={{ span: 14 }}
                                >
                                  <InputNumberItem disabled placeholder="Días de Crédito" />
                                </FormItem>
                              </Col>
                            )}

                            {/* Cuentas XC */}
                            {(contado === 1 || contado === 3) && !this.state.desactivarBtnCXC &&
                              <Col span={24} ref={this.refCuentasXC}>
                                <FormItem
                                  label="Cuentas XC"
                                  name="cuentasXC"
                                  initialValue={false}
                                  valuePropName="checked"
                                  labelCol={{ span: 8 }}
                                  wrapperCol={{ span: 12 }}
                                  margin
                                >
                                  <SwitchItem />
                                </FormItem>
                              </Col>
                            }

                              {/* Banco */}
                              {(contado === 1 || contado === 3) && !cuentasXC && (
                                <Col span={24}>
                                  <FormItem
                                    required={!cuentasXC}
                                    name="bancoId"
                                    label="Banco"
                                    margin
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 14 }}
                                  >
                                    <SelectItem
                                      placeholder="Banco"
                                      disabled
                                      noDisabledBackground
                                    >
                                      {this.state.objetoBancos}
                                    </SelectItem>
                                  </FormItem>
                                </Col>
                              )}

                              {/* Fecha de pago informativa - Solo en ventas No Contables.
                                  Va fuera del bloque de Banco para que tambien se vea a credito.
                                  A diferencia del resto de la pantalla si es editable: se guarda al cambiarla */}
                              {this.state.sinContabilidad && (
                                <Col span={24}>
                                  <FormItem
                                    name="fechaPagoInformativa"
                                    label="Fecha Pago"
                                    margin
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 14 }}
                                    tooltip="Fecha de pago informativa, no genera movimientos contables ni de cobranza"
                                  >
                                    <DatePickerItem
                                      placeholder="Fecha Pago"
                                      style={{ width: "100%" }}
                                      onChange={(fecha) => {
                                        axios
                                          .post(
                                            "ventas/editarFechaPagoInformativa",
                                            {
                                              ventaId: this.state.id,
                                              empresaId: this.props.empresaId,
                                              fechaPagoInformativa: fecha ? fecha.format("YYYY-MM-DD") : null,
                                            },
                                            { headers: this.props.headersToken }
                                          )
                                          .then((res) => {
                                            if (res.data.success !== 2) {
                                              message.warning("Error al guardar la fecha de pago");
                                            } else {
                                              message.success("Fecha de pago actualizada");
                                            }
                                          })
                                          .catch(() => {
                                            message.error("Error al guardar la fecha de pago");
                                          });
                                      }}
                                    />
                                  </FormItem>
                                </Col>
                              )}
                            </Row>
                          );
                        })()}
                      </>
                    )}
                    
                    regimenFiscalContent={(
                      <FormItem
                        name="regimenFiscalId"
                        margin
                        label="Régimen F."
                        required
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 14 }}
                      >
                        <SelectItem disabled noDisabledBackground placeholder="Regimen Fiscal">
                          {this.state.objetoRegimenFiscal}
                        </SelectItem>
                      </FormItem>
                    )}

                    monedaContent={(
                      <>
                        <FormItem
                          required
                          margin
                          name="monedaId"
                          label="Moneda"
                          initialValue='60c7e4396465ad440c41c15a'
                          labelCol={{ span: 8 }}
                          wrapperCol={{ span: 14 }}
                        >
                          <SelectItem disabled noDisabledBackground placeholder="Moneda">
                            {this.state.objetoMonedas}
                          </SelectItem>
                        </FormItem>
                        <FormItem
                          noStyle
                          shouldUpdate={(prevValues, currentValues) =>
                            prevValues.monedaId !== currentValues.monedaId
                          }
                        >
                          {({ getFieldValue }) => {
                            const monedaId = getFieldValue("monedaId");
                            // Ocultar T. Cambio si es la moneda MXN 
                            if (monedaId === "60c7e4396465ad440c41c15a") {
                              return null;
                            }
                            return (
                              <FormItem
                                required
                                number
                                margin
                                label="T. Cambio"
                                name="tipoDeCambio"
                                type="number"
                                initialValue={1}
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                              >
                                <InputNumberItem disabled dinero placeholder="T. Cambio" />
                              </FormItem>
                            );
                          }}
                        </FormItem>
                      </>
                    )}

                    showDoctor={this.props.equipoMedico}
                    showRegimenFiscal={this.state.activarRegimenes && this.state.factura}
                    showMoneda={true}
                    datosGeneralesCol={{ xs: 24, sm: 24, md: 24, lg: 18, xl: 18 }}
                    monedaCol={{ xs: 24, sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }}
                    gutter={[20, 16]}
                    belowDatosGeneralesTitle="CONTACTO VENTA ONLINE"
                    belowDatosGeneralesContent={this.state.ventaOnline ? (
                      <Row gutter={[16, 8]}>
                        <Col xs={24} sm={24} md={8} lg={8}>
                          <FormItem
                            label="Nombre"
                            margin
                            labelCol={{ span: 6 }}
                            wrapperCol={{ span: 18 }}
                          >
                            <InputItem
                              disabled
                              placeholder="Nombre del contacto"
                              value={`${this.state.clienteOnline?.nombre || ''} ${this.state.clienteOnline?.apellidoPaterno || ''} ${this.state.clienteOnline?.apellidoMaterno || ''}`.trim()}
                            />
                          </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={8}>
                          <FormItem
                            label="Correo"
                            margin
                            labelCol={{ span: 6 }}
                            wrapperCol={{ span: 18 }}
                          >
                            <InputItem
                              disabled
                              placeholder="Correo del contacto"
                              value={this.state.clienteOnline?.email || ''}
                            />
                          </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={8}>
                          <FormItem
                            label="Teléfono"
                            margin
                            labelCol={{ span: 6 }}
                            wrapperCol={{ span: 18 }}
                          >
                            <InputItem
                              disabled
                              celular
                              placeholder="Teléfono del contacto"
                              value={this.state.clienteOnline?.telefono || ''}
                            />
                          </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={8}>
                          <FormItem
                            label="Referencia de pago"
                            margin
                            labelCol={{ span: 12 }}
                            wrapperCol={{ span: 12 }}
                          >
                            <InputItem
                              disabled
                              placeholder="Referencia de pago"
                              value={this.state.referenciaPagoOnline || ''}
                            />
                          </FormItem>
                        </Col>
                      </Row>
                    ) : null}
                    tabs={[ 
                      {
                        key: "tabla",
                        label: "Insumos",
                        listName: "insumos",
                        tableLayout: "fixed",
                        columns: this.getInsumosColumns(), //Pasa el helper
                        renderRow: this.renderInsumoRow.bind(this),
                      },
                      {
                        key: "entrega",
                        label: "Entrega",
                        customContent: this.renderEntregaContent()
                      },
                      (this.state.insumosAnteriores && this.state.insumosAnteriores.length > 0) ? {
                        key: "insumos-anteriores",
                        label: "En Otras Ventas",
                        customContent: this.renderInsumosAnterioresContent()
                      } : null,
                     (this.state.ventaOnline && this.state.cotizacionesEnvioOnline && this.state.cotizacionesEnvioOnline.length > 0) ? {
                        key: "envio-online",
                        label: "Envío Online",
                        listName: "cotizacionesEnvioOnline", 
                        columns: this.getEnvioOnlineColumns(),
                        renderRow: this.renderEnvioOnlineRow.bind(this)
                      } : null,
                      this.state.flete && this.props.fletes ? {
                        key: "envio",
                        label: "Envío",
                        forceRender: true,
                        customContent: (
                          <TabEnvio
                            editarMercanciasEnvio={this.editarMercanciasEnvio.bind(this)}
                            editarUbicacionesEnvio={this.editarUbicacionesEnvio.bind(this)}
                            ubicacionesEnvio={this.state.ubicacionesEnvio}        
                            mercanciasEnvio={this.state.mercanciasEnvio}          
                            formRefGeneral={this.formRef}
                            todasClientes={this.state.todasClientes}             
                            disabled
                          />
                        )
                      } : null,
                      this.state.factura ? {
                        key: "cfdi-relacionados",
                        label: "CFDIs Relacionados",
                        forceRender: true,
                        customContent: <TabRelaciones disabled />
                      } : null,

                    ].filter(Boolean)}
                    defaultActiveKey="tabla"
                    isMobile={window.innerWidth <= 1000}
                    formInstance={this.formRef.current}
                    onTabChange={(key) => {
                      if (key === "entrega") {
                        this.consultarInformacionEntrega()
                      }
                      this.setState({ activeTabKey: key })
                    }}

                    observacionesConfig={this.getObservacionesConfig()}

                    actionButtons={(
                      <>
                        {this.state.estado !== 0 ?
                          <ButtonItem
                            type="primary"
                            blanco
                            icon={<IconAd2 />}
                            onClick={this.requerirInsumos.bind(this)}
                          >
                            Requerir Insumos
                          </ButtonItem>
                          : null}
                        {this.state.estado !== 0 && this.state.requerido ?
                          <ButtonItem
                            type="primary"
                            cafeB
                            icon={<IconAd2 />}
                            onClick={() => this.setState({ modalRastrearRequisicion: true })}
                          >
                            Rastrear Requisiciones
                          </ButtonItem>
                          : null}
                        {(this.state.estado === 1 || this.state.estado === 2) && this.props.permisoApartarInsumosVenta ?
                          <ButtonItem
                            type="primary"
                            naranjaB
                            icon={<IconAd2 />}
                            onClick={this.apartarInsumos.bind(this)}
                          >
                            Apartar Insumos
                          </ButtonItem>
                          : null}
                        {this.props.permitirCambiarClienteVenta && this.props.permisoCambiarClienteVenta ?
                          <ButtonItem
                            type="primary"
                            moradoB
                            icon={<SwapOutlined />}
                            loading={this.state.loadingCambiarCliente}
                            onClick={this.abrirModalCambiarCliente}
                          >
                            Cambiar Cliente
                          </ButtonItem>
                          : null}
                        {this.props.permitirEditarRemisionVenta && this.props.permisoEditarRemisionVenta &&
                          this.state.remision && !this.state.factura && this.state.estado !== 0 && Number(this.state.totalPagado || 0) === 0 ?
                          <ButtonItem
                            type="primary"
                            azulMB
                            icon={<EditOutlined />}
                            onClick={this.abrirModalEditarRemision}
                          >
                            Editar Remisión
                          </ButtonItem>
                          : null}
                        {this.props.permitirDividirVentaPorPartidas && this.props.permisoDividirRemisionParaFacturar &&
                          this.state.remision && !this.state.factura && !this.state.facturaId && this.state.estado !== 0 && Number(this.state.totalPagado || 0) === 0 ?
                          <ButtonItem
                            type="primary"
                            moradoB
                            icon={<IconFileInvoice />}
                            onClick={this.abrirModalDividirVenta}
                          >
                            Dividir Remisión para Facturar
                          </ButtonItem>
                          : null}
                        {this.state.ventaPadreId ?
                          <ButtonItem
                            type="primary"
                            negroB
                            icon={<IconFileInvoice />}
                            onClick={() => this.props.history.push('/panel/verVenta', { id: this.state.ventaPadreId })}
                          >
                            Ver Venta Original
                          </ButtonItem>
                          : null}
                        {this.state.ventasDerivadas && this.state.ventasDerivadas.length > 0 ?
                          <Dropdown
                            trigger={['click']}
                            overlay={
                              <Menu>
                                {this.state.ventasDerivadas.map((valueVenta) => (
                                  <Menu.Item
                                    key={valueVenta._id}
                                    onClick={() => this.props.history.push('/panel/verVenta', { id: valueVenta._id })}
                                  >
                                    {(valueVenta.remisionSerie || 'R') + ' - ' + valueVenta.remisionNumero + (valueVenta.sufijoPartida ? (' ' + valueVenta.sufijoPartida) : '')}
                                    {valueVenta.facturaId ? ' (Ya facturado)' : ' (Dividido)'}
                                  </Menu.Item>
                                ))}
                              </Menu>
                            }
                          >
                            <ButtonItem type="primary" cyanB icon={<IconFileInvoice />}>
                              Ventas Derivadas <DownOutlined />
                            </ButtonItem>
                          </Dropdown>
                          : null}
                        {this.state.apartado && this.state.estado !== 0 ?
                          <Dropdown
                            trigger={['click']}
                            overlay={
                              <Menu>
                                <Menu.Item key="general" onClick={() => Modal.confirm({
                                  title: '¿Seguro que quiere quitar todos los apartados?',
                                  okText: 'Sí',
                                  cancelText: 'Cancelar',
                                  onOk: () => this.desapartarInsumos(),
                                })}>
                                  General
                                </Menu.Item>
                                <Menu.Item key="individual" onClick={() => this.abrirModalQuitarApartadoIndividual()}>
                                  Individual
                                </Menu.Item>
                              </Menu>
                            }
                          >
                            <ButtonItem
                              type="primary"
                              verdeB
                              icon={<IconAd2 />}
                            >
                              Quitar Apartado <DownOutlined />
                            </ButtonItem>
                          </Dropdown>
                          : null}
                        {this.state.ticket ?
                          <ButtonItem
                            type="primary"
                            icon={<SnippetsOutlined />}
                            naranjaB
                            onClick={() => this.imprimirTicket(this.state.id)}
                          >
                            Reimprimir Ticket
                          </ButtonItem>
                          : null}
                        {/* Misma regla que el boton "F" del listado de Ventas, mas estado !== 0 y
                            !facturaId (remision ya incluida en una factura de varias remisiones). */}
                        {this.state.remision && !this.state.factura && !this.state.facturaId && !this.state.facturaGlobal &&
                          !this.state.sinContabilidad && this.state.estado !== 0 &&
                          !(this.state.ventaOnline && this.state.estadoPago !== 3) &&
                          this.props.certificada && this.props.permisoFacturarVentas &&
                          (this.state.estadoPago === 0 || this.state.contado === 1 || this.state.facturarConDevoluciones) ?
                          <ButtonItem
                            type="primary"
                            icon={<IconFileInvoice />}
                            limaB
                            onClick={() => this.props.history.push('/panel/generarFacturaVenta', { id: this.state.id })}
                          >
                            Facturar
                          </ButtonItem>
                          : null}
                        {this.state.factura && this.state.estado !== 0 && (this.state.estadoPago === 0 || this.state.contado === 1) ?
                          <ButtonItem
                            type="primary"
                            icon={<IconFileInvoice />}
                            lilaB
                            onClick={() => this.refacturarVenta(this.state.id)}
                          >
                            Refacturar
                          </ButtonItem>
                          : null}
                        {this.state.estado !== 0 ?
                          <ButtonItem
                            type="primary"
                            icon={<SnippetsOutlined />}
                            cafeB
                            onClick={this.agregarDevolucion.bind(this)}
                          >
                            Agregar Devolucion
                          </ButtonItem>
                          : null}
                        {this.state.devolucion ?
                          <ButtonItem
                            type="primary"
                            icon={<SnippetsOutlined />}
                            blanco
                            onClick={() => this.setState({ modalDevoluciones: true })}
                          >
                            Devoluciones
                          </ButtonItem>
                          : null}
                        {this.state.estado !== 0 ?
                          <ButtonItem
                            type="primary"
                            icon={<SnippetsOutlined />}
                            cafeB
                            onClick={this.agregarNotaDeCreditoVenta.bind(this)}
                          >
                            Agregar Nota Crédito
                          </ButtonItem>
                          : null}
                        {this.state.notaDeCredito ?
                          <ButtonItem
                            type="primary"
                            icon={<SnippetsOutlined />}
                            blanco
                            onClick={() => this.setState({ modalNotasDeCreditoVenta: true })}
                          >
                            Notas de credito
                          </ButtonItem>
                          : null}
                        {(this.state.estado === 0 && this.state?.facturaId) && (
                          <ButtonItem
                            type="primary"
                            lilaB
                            onClick={() => this.setState({ modalVerFacturaVariasRemisiones: true })}
                          >
                            Factura
                          </ButtonItem>
                        )}
                        {(this.state?.remisionesIds && this.state?.remisionesIds?.length > 0) && (
                          <ButtonItem
                            type="primary"
                            lilaB
                            onClick={() => this.setState({ modalVerRemisionesVariasFactura: true })}
                          >
                            Remisiones
                          </ButtonItem>
                        )}
                        {this.state.ajusteFacturaDevolucion && (
                          <ButtonItem
                            type="primary"
                            lilaB
                            onClick={() => this.setState({ modalAjusteFacturaDevolucion: true })}
                          >
                            Ver Ajuste por Devolución
                          </ButtonItem>
                        )}
                        {/* Solo estado 0: `cancelacion` existe en toda venta (cancelacion.sinSat
                            tiene default false), asi que no sirve para saber si esta cancelada. */}
                        {this.state.estado === 0 && (
                          <ButtonItem
                            type="primary"
                            rojoB
                            onClick={() => this.setState({ modalCancelarPdf: true })}
                          >
                            Cancelación
                          </ButtonItem>
                        )}
                        {this.state.totalPagado > 0 && this.state.estado !== 0 && (
                          <ButtonItem
                            type="primary"
                            icon={<DollarOutlined />}
                            verdeB
                            onClick={() => this.setState({ modalPagos: true })}
                          >
                            Pagos
                          </ButtonItem>
                        )}
                        <ButtonItem
                          type="primary" 
                          icon={<CarOutlined />}
                          verdeB
                          onClick={() => this.setState({ modalEntregas: true })}
                        >
                          Entregas
                        </ButtonItem>
                        <ButtonItem
                          type="primary" 
                          icon={<CarOutlined />}
                          naranjaB
                          onClick={() => this.setState({ modalApartados: true })}
                        >
                          Apartados
                        </ButtonItem>
                        <ButtonItem
                          icon={<DownloadOutlined />}
                          arenaB
                          onClick={() => this.descargarPDF(this.state.id)}
                        >
                          Descargar PDF
                        </ButtonItem>
                        <ButtonItem
                          icon={<FileExcelOutlined />}
                          verdeB
                          loading={this.state.descargandoExcel}
                          onClick={this.descargarExcel.bind(this)}
                        >
                          Descargar Excel
                        </ButtonItem>
                        {this.state.factura ?
                          <ButtonItem
                            icon={<DownloadOutlined />}
                            arenaB
                            onClick={() => this.descargarXml(this.state.id)}
                          >
                            Descargar xml
                          </ButtonItem> : null}
                        {this.state.flete && this.props.fletes && !this.state.factura && this.props.permisoFacturarVentas && this.state.estado !== 0 && !this.state.dataCartaPorteTraslado?.uuid ?
                          <ButtonItem
                            type="primary"
                            icon={<CarOutlined />}
                            moradoB
                            onClick={this.emitirCartaTrasladoRemision.bind(this)}
                          >
                            Emitir Carta de Traslado
                          </ButtonItem> : null}
                        {this.state.flete && this.props.fletes && !this.state.factura && this.props.permisoFacturarVentas && this.state.dataCartaPorteTraslado?.uuid ?
                          <ButtonItem
                            type="primary"
                            icon={<CarOutlined />}
                            moradoB
                            onClick={this.abrirModalCartaTraslado.bind(this)}
                          >
                            Ver Carta de Traslado
                          </ButtonItem> : null}
                        {this.state.flete && this.props.fletes && !this.state.factura && this.props.permisoFacturarVentas && this.state.dataCartaPorteTraslado?.uuid && !this.state.cancelacionCartaPorteTraslado?.fechaCancelacion ?
                          <ButtonItem
                            type="primary"
                            icon={<CarOutlined />}
                            rojoB
                            onClick={this.abrirModalCancelarCartaTraslado.bind(this)}
                          >
                            Cancelar Carta de Traslado
                          </ButtonItem> : null}
                        {this.state.cambioContadoACredito && this.state.estado !== 0 ?
                          <Tooltip title="Cambiar venta de contado a crédito">
                            <Popconfirm
                              title="¿Estás seguro de cambiar esta venta de contado a crédito?"
                              onConfirm={this.cambiarACredito.bind(this)}
                              okText="Ok"
                              cancelText="Cancelar"
                            >
                              <ButtonItem
                                type="primary"
                                icon={<DollarOutlined />}
                                rosaB
                              >
                                Cambiar a Crédito
                              </ButtonItem>
                            </Popconfirm>
                          </Tooltip>
                          : null}
                        {this.state.cambioCreditoAContado && this.state.estado !== 0 ?
                          <Tooltip title="Cambiar venta de crédito a contado">
                            <Popconfirm
                              title="¿Estás seguro de cambiar esta venta de crédito a contado?"
                              onConfirm={this.cambiarAContado.bind(this)}
                              okText="Ok"
                              cancelText="Cancelar"
                            >
                              <ButtonItem
                                type="primary"
                                icon={<DollarOutlined />}
                                rosaB
                              >
                                Cambiar a Contado
                              </ButtonItem>
                            </Popconfirm>
                          </Tooltip>
                          : null}
                        {this.state.facturaGlobal ?
                          <ButtonItem
                            type="primary"
                            icon={<BookOutlined />}
                            naranjaB
                            onClick={() => this.verFacturaGlobal(this.state.facturaGlobalId)}
                          >
                            Factura Global
                          </ButtonItem>
                          : null}
                        {this.state.facturaGlobal && this.state.estado !== 0 ?
                          <ButtonItem
                            type="primary"
                            icon={<IconFileInvoice />}
                            moradoB
                            onClick={() => this.setState({ modalFacturarQuitarGlobal: true })}
                          >
                            Facturar / Quitar de Global
                          </ButtonItem>
                          : null}
                        {this.state.facturaGlobal && this.state.estado !== 0 ?
                          <Popconfirm
                            title={'Se generara una nota de credito a PUBLICO GENERAL para quitar la venta de la factura global. ¿Desea continuar?'}
                            onConfirm={this.quitarVentaDeGlobal.bind(this)}
                            okText="Ok"
                            cancelText="Cancelar"
                          >
                            <ButtonItem
                              type="primary"
                              icon={<IconFileInvoice />}
                              rojoB
                            >
                              Quitar de Factura Global
                            </ButtonItem>
                          </Popconfirm>
                          : null}
                        <ButtonItem
                          type="primary"
                          icon={<FileOutlined />}
                          azulMB
                          onClick={() => this.setState({ modalResumenInsumos: true })}
                        >
                          Resumen de Insumos
                        </ButtonItem>
                        {this.props.permisoVerPolizasEnDocumentos && (
                          <ButtonItem
                            type="primary"
                            hotkey="shift+z"
                            icon={<BookOutlined />}
                            azulMB
                            onClick={() => this.setState({ modalPolizas: true })}
                          >
                            Ver Pólizas
                          </ButtonItem>
                        )}
                        <ButtonItem
                          type="primary"
                          hotkey="shift+m"
                          icon={<SendOutlined />}
                          azulMB
                          onClick={() => this.enviarVenta(this.state.id)}
                        >
                          Mandar Correo
                        </ButtonItem>
                        <ButtonItem
                          type="primary"
                          hotkey="shift+r"
                          rojoB
                          onClick={this.atras.bind(this)}
                        >
                          Regresar
                        </ButtonItem>
                      </>
                    )}
                  />
            </Form>
          </Spin>
        </div>
        <MandarCorreo
          visible={this.state.modalCorreo}
          id={this.state.modalCorreoId}
          cerrarMandarCorreo={this.cerrarMandarCorreo.bind(this)}
        />
        <MandarCorreoCartaTrasladoRemision
          visible={this.state.modalCartaTrasladoVisible}
          ventaId={this.state.id}
          cerrarMandarCorreoCartaTrasladoRemision={this.cerrarMandarCorreoCartaTrasladoRemision.bind(this)}
        />
        <CancelarCartaTrasladoRemision
          visible={this.state.modalCancelarCartaTrasladoVisible}
          ventaId={this.state.id}
          cerrarCancelarCartaTrasladoRemision={this.cerrarCancelarCartaTrasladoRemision.bind(this)}
          actualizarDespuesDeCancelar={this.actualizarDespuesDeCancelarCartaTraslado.bind(this)}
        />
        <PagosVenta
          visible={this.state.modalPagos}
          id={this.state.id}
          cerrarPagosVenta={this.cerrarPagosVenta.bind(this)}
        />
        <EntregasVenta
          visible={this.state.modalEntregas}
          id={this.state.id}
          cerrarEntregasVenta={this.cerrarEntregasVenta.bind(this)}
          insumos={this.state.insumosEntrega}
          insumosVenta={this.state.insumosEntregaVenta}
        />
        <MandarCorreoFacturaGlobal
          visible={this.state.modalVerFacturaGlobal}
          id={this.state.modalVerFacturaGlobalId}
          history={this.props.history}
          cerrarMandarCorreoFacturaGlobal={this.cerrarMandarCorreoFacturaGlobal.bind(this)}
        />
        <NotasDeCreditoVenta
          history={this.props.history}
          visible={this.state.modalNotasDeCreditoVenta}
          id={this.state.id}
          cerrarNotasDeCreditoVenta={this.cerrarNotasDeCreditoVenta.bind(this)}
        />
        <DevolucionesVenta
          history={this.props.history}
          visible={this.state.modalDevoluciones}
          id={this.state.id}
          cerrarDevolucionesVenta={this.cerrarDevolucionesVenta.bind(this)}
        />
        <ModalCancelarPdf
          visible={this.state.modalCancelarPdf}
          ventaId={this.state.id}
          onCancel={this.cerrarModalCancelarPdf.bind(this)}
          cerrarModalPdf={this.cerrarModalCancelarPdf.bind(this)}
        />

        <ModalRefacturarVenta
          visible={this.state.modalRefacturarVenta}
          cerrarModalRefacturar={this.cerrarModalRefacturar.bind(this)}
          ventaId={this.state.ventaIdRefacturar}
          empresaId={this.state.empresaId}
          headersToken={this.props.headersToken}
          impresoraSeleccionada={this.props.impresoraSeleccionada}
        />

        <ModalFacturarQuitarGlobal
          visible={this.state.modalFacturarQuitarGlobal}
          cerrarModalFacturarQuitarGlobal={this.cerrarModalFacturarQuitarGlobal.bind(this)}
          ventaId={this.state.id}
          impresoraSeleccionada={this.props.impresoraSeleccionada}
        />

        <RastrearRequisicion
          visible={this.state.modalRastrearRequisicion}
          id={this.state.id}
          cerrarRastrearRequisicion={this.cerrarRastrearRequisicion.bind(this)}
        />

        <ModalVerFacturaVariasRemisiones
          visible={this.state.modalVerFacturaVariasRemisiones}
          id={this.state.id}
          cerrarVerFacturaVariasRemisiones={(direccionar, id) => this.cerrarVerFacturaVariasRemisiones(direccionar, id)}
        />

        <ModalVerRemisionesVariasFactura
          visible={this.state.modalVerRemisionesVariasFactura}
          id={this.state.id}
          cerrarVerRemisionesVariasFacturas={(direccionar, id) => this.cerrarVerRemisionesVariasFacturas(direccionar, id)}
        />
        <EnviarCorreoCostearVenta
          visible={this.state.modalVisibleCorreoCosteo}
          costeoId={this.state.modalVisibleCorreoCosteoId}
          cerrarMandarCorreo={this.cerrarModalCorreoCosteo.bind(this)}
          ventaId={this.state.id}
          insumoId={this.state.modalVisibleCorreoCosteoId}
        />

        
        <ModalGenerarGuia
          visible={this.state.modalGuiaLocalVisible}
          ventaId={this.state.id}
          origenKey={this.state.selectedOrigenKey}
          onCancel={this.cerrarModalEnvio}
          onSuccess={this.onSuccessModalEnvio}
        />
        
        <ModalGenerarOCDropshipping
          visible={this.state.modalGuiaDropshippingVisible}
          ventaId={this.state.id}
          origenKey={this.state.selectedOrigenKey}
          onCancel={this.cerrarModalEnvio}
          onSuccess={this.onSuccessModalEnvio}
        />

        <ModalGenerarGuiaManual
          visible={this.state.modalGuiaManualVisible}
          ventaId={this.state.id}
          origenKey={this.state.selectedOrigenKey}
          onCancel={this.cerrarModalEnvio}
          onSuccess={this.onSuccessModalEnvio}
        />

        <ApartadosVenta
          visible={this.state.modalApartados}
          id={this.state.id}
          cerrarApartadosVenta={() => this.setState({ modalApartados: false })}
        />
        <ModalResumenInsumos
          visible={this.state.modalResumenInsumos}
          ventaId={this.state.id}
          onCancel={() => this.setState({ modalResumenInsumos: false })}
        />
        <ModalQuitarApartadoIndividual
          visible={this.state.modalQuitarApartadosIndividual}
          onCancel={() => this.setState({ modalQuitarApartadosIndividual: false })}
          insumos={this.state.insumosParaQuitarApartado}
          onConfirm={this.desapartarInsumosIndividual.bind(this)}
          loading={this.state.loading}
        />
        <DetalleInsumoModal
          visible={this.state.modalDetalleInsumoVisible}
          onClose={this.cerrarDetalleInsumo}
          insumoId={this.state.insumoSeleccionadoDetalle.id}
          nombreInsumo={this.state.insumoSeleccionadoDetalle.nombre}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
        />
        <DisponibilidadInsumoModal
          visible={this.state.modalDisponibilidadVisible}
          onClose={this.cerrarDisponibilidad}
          insumoId={this.state.insumoSeleccionadoDisponibilidad.id}
          nombreInsumo={this.state.insumoSeleccionadoDisponibilidad.nombre}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
          proyectoId={this.state.insumoSeleccionadoDisponibilidad.proyectoId}
        />
        <HistorialInsumoClienteModal
          visible={this.state.modalHistorialClienteVisible}
          onClose={this.cerrarHistorialCliente}
          insumoId={this.state.insumoSeleccionadoHistorial.id}
          nombreInsumo={this.state.insumoSeleccionadoHistorial.nombre}
          clienteId={this.state.insumoSeleccionadoHistorial.clienteId}
          excluirId={this.state.id}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
        />
        <ComponentesKitModal
          visible={this.state.modalComponentesKitVisible}
          onClose={this.cerrarComponentesKit}
          componentes={this.state.componentesKitSeleccionado.componentes}
          cantidadLinea={this.state.componentesKitSeleccionado.cantidad}
          nombreInsumo={this.state.componentesKitSeleccionado.nombre}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
        />
        <ModalItem
          title="Cambiar Cliente"
          visible={this.state.modalCambiarCliente}
          onCancel={() => this.setState({ modalCambiarCliente: false, clienteNuevoId: null })}
          onOk={this.ejecutarCambiarCliente}
          okText="Cambiar"
          cancelText="Cancelar"
          confirmLoading={this.state.loadingCambiarCliente}
          spinning={false}
          footer
          destroyOnClose
        >
          <p style={{ marginBottom: 12 }}>
            Solo se muestran clientes con el mismo RFC que el cliente actual.
          </p>
          <Select
            style={{ width: '100%' }}
            placeholder="Selecciona cliente"
            value={this.state.clienteNuevoId}
            onChange={(val) => this.setState({ clienteNuevoId: val })}
            optionFilterProp="children"
            showSearch
          >
            {this.state.clientesCandidatos.map(c => (
              <Option key={c._id} value={c._id}>
                {c.stringBuscar || c.razonSocial || `${c.nombre || ''} ${c.apellidoPaterno || ''} ${c.apellidoMaterno || ''}`.trim()} — {c.rfc}
              </Option>
            ))}
          </Select>
        </ModalItem>
        <ModalItem
          title="Ajuste por Devolución"
          visible={this.state.modalAjusteFacturaDevolucion}
          onCancel={() => this.setState({ modalAjusteFacturaDevolucion: false })}
          spinning={false}
          paddingTop
        >
          {this.state.ajusteFacturaDevolucion && (
            <div>
              <p style={{ marginBottom: 12 }}>
                Esta factura se generó excluyendo insumos ya devueltos y compensados contra la deuda.
              </p>
              <table className="table" style={{ marginBottom: 20 }}>
                <thead>
                  <tr>
                    <th></th>
                    <th style={{ textAlign: "right" }}>Antes</th>
                    <th style={{ textAlign: "right" }}>Facturado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>Subtotal</th>
                    <td style={{ textAlign: "right" }}>{dineroDisabledMask(this.state.ajusteFacturaDevolucion.subtotalAntes)}</td>
                    <td style={{ textAlign: "right" }}>{dineroDisabledMask(this.state.subtotal)}</td>
                  </tr>
                  <tr>
                    <th>Total</th>
                    <td style={{ textAlign: "right" }}>{dineroDisabledMask(this.state.ajusteFacturaDevolucion.totalAntes)}</td>
                    <td style={{ textAlign: "right" }}>{dineroDisabledMask(this.state.total)}</td>
                  </tr>
                  <tr>
                    <th>Total a Pagar</th>
                    <td style={{ textAlign: "right" }}>{dineroDisabledMask(this.state.ajusteFacturaDevolucion.totalPagarAntes)}</td>
                    <td style={{ textAlign: "right" }}>{dineroDisabledMask(this.state.totalPagar)}</td>
                  </tr>
                </tbody>
              </table>
              <p style={{ marginBottom: 8, fontWeight: 600 }}>Insumos excluidos:</p>
              <table className="table">
                <thead>
                  <tr>
                    <th>Insumo</th>
                    <th style={{ textAlign: "right" }}>Cantidad excluida</th>
                    <th style={{ textAlign: "right" }}>Monto excluido</th>
                  </tr>
                </thead>
                <tbody>
                  {(this.state.ajusteFacturaDevolucion.insumosExcluidos || []).map((valueInsumo, index) => {
                    const insumoCatalogo = this.state.todasInsumos?.find(
                      (i) => i._id?.toString() === valueInsumo.insumoId?.toString()
                    );
                    return (
                      <tr key={index}>
                        <td>{insumoCatalogo?.nombreClienteAlternativo || insumoCatalogo?.nombre || insumoCatalogo?.descripcion || valueInsumo.insumoId}</td>
                        <td style={{ textAlign: "right" }}>{valueInsumo.cantidadExcluida}</td>
                        <td style={{ textAlign: "right" }}>{dineroDisabledMask(valueInsumo.totalExcluido)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </ModalItem>
        <CambiarInsumoVenta
          visible={this.state.modalCambiarInsumoVisible}
          ventaId={this.state.id}
          insumoVentaId={this.state.modalCambiarInsumoData?.insumoVentaId}
          insumoId={this.state.modalCambiarInsumoData?.insumoId}
          proyectoId={this.state.modalCambiarInsumoData?.proyectoId}
          entregado={this.state.modalCambiarInsumoData?.entregado}
          cerrarCambiarInsumo={this.cerrarModalCambiarInsumo}
        />
        <EditarRemisionVenta
          visible={this.state.modalEditarRemisionVisible}
          ventaId={this.state.id}
          cerrarEditarRemision={this.cerrarModalEditarRemision}
        />
        <ModalDividirVenta
          visible={this.state.modalDividirVentaVisible}
          ventaId={this.state.id}
          insumos={this.state.insumosParaDividir}
          todasInsumos={this.state.todasInsumos}
          cerrarDividirVenta={this.cerrarModalDividirVenta}
        />
        <ModalPolizasDocumento
          visible={this.state.modalPolizas}
          tipo="venta"
          documentoId={this.state.id}
          titulo="Pólizas de la Venta"
          onCancel={() => this.setState({ modalPolizas: false })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    fletes: state.empresa.fletes,
    equipoMedico: state.empresa.equipoMedico,
    activarPagare: state.empresa.activarPagare,
    quitarImpuestosOpcionalVentas: state.empresa.quitarImpuestosOpcionalVentas,
    impresoraSeleccionada: state.empresa.impresoraSeleccionada,
    permisoApartarInsumosVenta:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "68e49ebc75bb93249195301e"
      )?.activado,
    permitirCambiarClienteVenta: state.empresa.permitirCambiarClienteVenta,
    permisoCambiarClienteVenta:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a454235e009eb3a781981e2"
      )?.activado,
    permitirCambiarInsumoVenta: state.empresa.permitirCambiarInsumoVenta,
    permisoCambiarInsumoVenta:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a60fbe52057b6dbf3444600"
      )?.activado,
    permitirEditarRemisionVenta: state.empresa.permitirEditarRemisionVenta,
    permitirDividirVentaPorPartidas: state.empresa.permitirDividirVentaPorPartidas,
    permisoEditarRemisionVenta:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a650aa0894b3d00e662edae"
      )?.activado,
    certificada: state.empresa.certificada,
    permisoFacturarVentas:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615ce36bf30e81b54183cfaf"
      )?.activado,
    permisoVerPolizasEnDocumentos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a9b57f6e58adfd453dfa5f4"
      )?.activado,
    // Permiso "Dividir remisión para facturar" (#125).
    permisoDividirRemisionParaFacturar:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6ab2e1f228e43beedf1d5aff"
      )?.activado,
  };
};

export default connect(mapStateToProps)(VerVenta);